import { Component, NgModule , OnDestroy, OnInit,  EventEmitter, Input, Output, ViewContainerRef,
  OnChanges, TemplateRef, ViewChild, ViewEncapsulation} from '@angular/core';
import {DemoService} from '../../../demo.service';
// import { HotToastService } from '@ngneat/hot-toast';
import {Routes, RouterModule, Router} from '@angular/router';
import { MysqlService } from './../../../services/mysql.service';

// 
import { Job } from '../../../shared/models/job.model';
import { DatePipe } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { FormsModule, NgForm } from '@angular/forms';
import { HttpClientModule, HttpRequest, HttpResponse, HttpEvent } from '@angular/common/http';

// import { Observable } from 'rxjs/Observable'; // this created errors ats use below
import {BehaviorSubject, Observable, Subject, map} from 'rxjs';
import { Subscription } from 'rxjs';

import { FileUploaderService } from './../../../services/file-uploader-service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { GlobalFunctionsService } from './../../../services/global-functions.service';
import { LegalDateTimeService } from './../../../services/legal-datetime.service';
// import { SubjectService } from './../../../shared/models/subjectService.model';
import { SubjectService } from './../../../api/subjectService';

import { DataUtil } from '@syncfusion/ej2-data';
import { HotToastService } from '@ngneat/hot-toast';
import { DomSanitizer } from '@angular/platform-browser';
import { Clipboard } from '@angular/cdk/clipboard'; // using the clipboard
import * as moment from 'moment';
import { CountService, HtmlEditorService, ImageService, LinkService, PasteCleanupService, ToolbarService } from '@syncfusion/ej2-angular-richtexteditor';


@Component({
  selector: 'app-subject-attempt-edit-widget',
  templateUrl: './subject-attempt-edit-widget.component.html',
  styleUrls: ['./subject-attempt-edit-widget.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [ToolbarService, LinkService, ImageService, HtmlEditorService, CountService, PasteCleanupService ]
})
export class SubjectAttemptEditWidgetComponent implements OnInit {
 





/*
job_id: any;
subject_id: any;
*/

public passed_job_id: string;
allAutomations = [];
allSubjects = [];
sections: { [key: string]: boolean } = {};

@ViewChild('attemptForm') form: any;


   // setup as observable?
   @Input() item_id?: Observable<any[]>; // impliments on changes.:    Observable<any[]>
   @Input() item_data?: Observable<any[]>; // if data.model is sent : Observable<any[]>; : Observable<any[]>
   @Input() use_item_data? = 'no'; // if data.model is sent use this instead of item_id
   @Input() item_user_level_id? = '5'; // default to agent just in case
   @Input() item_brand_type_id? = '';
   @Input() show_buttons? = 'no'; // yes | no
   @Input() widget_title? = '';
   @Input() widget_size? = 'side'; // side | abstract | full

   job: Object;
   job_id;

   @Input() intialCount? = 221;
   @Input() count? = this.intialCount;
   @Output('closeParentModel') closeParentModel: EventEmitter<any> = new EventEmitter();

   model: SubjectService;
 job_plaintiff_types: any;
  subject_service_id: any;
  subject_service: any;

  @Input() subject_contact_email_id?: any;


  currentUserVAR: any;
  sessionUserId: any;
  sessionUsername: any;
  sessionBrandId: any;
  brand_id: any;
  subject_notes: any;
 // bsModalRef: BsModalRef;
  modalRef: BsModalRef;
  public mytime: Date = new Date();
  staffList: any;
  serviceMethods: any;
  subjectRelationships: any;
  exactServiceMethods: any;
  get_latest_subject_service_id: any;
  subject_services: any;
  serviceOutcomes: any;
  assignedList: any;
  assignedBrandList: any;
  subjectServiceOutcome: any;
  current_subject: any;
  subjectLocationStatuss: any;
  subjectLocationStatussFound: any;
  brand: any;
  idx: any;
  title: any;
  current_service_number: any;
  converted_service_number: number;
  subjectAttemptTypesList: any;
  subject_attempt_type_label: string;
  @Input() subject_id?: number; // impliments on changes.

       // access the template form
@ViewChild('attemptForm') attemptForm: NgForm;
// @ViewChild('attemptForm') attemptForm: NgForm;



  all_router_details: string;
  nav: any;
  subjectAttemptType: any;
  email_address_served: string;
  subject_contact_emails: any;

  allAttachments = [];
  property_images = [];
  property_sign_images = [];
  property_mail_images = [];
  property_vehicles_images = [];
  property_pets_images = [];
  property_occupancy_images = [];
  property_condition_images = [];
  property_type_images = [];
  service_file_array = [];

  set_job_file: number;
  set_subject_file: number;
  // service_file_array: any;
  subject_service_results: any;
  subject_outcome_type_label: string;
  phone_number: string;
  subject_contact_numbers: any;

  is_count: number; // if service is part of counts
  is_count_subject_service_outcome_lookup: any;

  showNewAddress: boolean;
  propertyTypesList: any;
  showAllAttachments: boolean;
  client_reference: any;
  owner_trace_code: any;
  job_subjects: any;
  service_local_timezone: string;


 // defined the array of data
 public data_timezones: { [key: string]: Object }[] = [ 
  // { Id: 'game1', Game: 'Badminton' },
  // { Id: 'game2', Game: 'Football' },
  // { Id: 'game3', Game: 'Tennis' }
  
  { Id: 'Pacific/Norfolk', Timezone: 'Pacific/Norfolk', Offset: '+11:00', DST: '+12:00'  },
  { Id: 'Antarctica/Casey', Timezone: 'Antarctica/Casey', Offset: 'UTC+08:00', DST: '+11:00'  },
  { Id: 'Australia/Lord_Howe', Timezone: 'Australia/Lord_Howe', Offset: '+10:30', DST: '+11:00'  },
  { Id: 'Antarctica/Macquarie', Timezone: 'Antarctica/Macquarie', Offset: '+10:00', DST: '+11:00'  },
  { Id: 'Australia/Sydney', Timezone: 'Australia/Sydney', Offset: '+10:00', DST: '+11:00'  },
  { Id: 'Australia/Hobart', Timezone: 'Australia/Hobart', Offset: '+10:00', DST: '+11:00'  },
  { Id: 'Australia/Melbourne', Timezone: 'Australia/Melbourne', Offset: '+10:00', DST: '+11:00'  },
  { Id: 'Australia/Brisbane', Timezone: 'Australia/Brisbane', Offset: '+10:00', DST: '+11:00'  },
  { Id: 'Australia/Lindeman', Timezone: 'Australia/Lindeman', Offset: '+10:00', DST: '+11:00'  },
  { Id: 'Australia/Broken_Hill', Timezone: 'Australia/Broken_Hill', Offset: '+9:30', DST: '+10:30'  },
  { Id: 'Australia/Adelaide', Timezone: 'Australia/Adelaide', Offset: '+9:30', DST: '+10:30'  },
  { Id: 'Australia/Darwin', Timezone: 'Australia/Darwin', Offset: '+9:30', DST: '+09:30'  },
  { Id: 'Australia/Eucla', Timezone: 'Australia/Eucla', Offset: '+8:45', DST: '+08:45'  },
  { Id: 'Australia/Perth', Timezone: 'Australia/Perth', Offset: '+8:00', DST: '+08:00'  },
  
  
  ];
  // maps the appropriate column to fields property
  public fields_timezones: Object = { text: 'Timezone', value: 'Id' };
  //set the placeholder to DropDownList input
  public text_timezones: string = "Select a Agent Local Timezone";
  local_date_time: Date;
  local_date_time_offset: number;
  local_date_time_zone: string;
  service_local_offset: number;
  service_local: string;
  show_paragraph: number;

  load_ssot_id: number;
  subject_service_outome_template: Object;
  subject_service_outome_template_resolution_outcomes: any;
  subject_service_resolution_outcome_required: any;
  // show_paragraph: number;
  changes_made: any;
  current_job_fields: any;
  job_model: any;
  subject_model: any;
  subject_service_types: Object;
  subject_service_type: any;
  subject_attempt_type: any;
  subject_service_method: any;
  subject_service_agent: any;
  var_subject_attempt_type_name_Upper: any;
  var_service_method_name: any;
  serviceFellowRelationship: Object;
  subject_service_fellow_relationship: any;
  subjectExactServiceMethod: any;
  subjectLocationStatus: any;
  subjectLocationStatusFound: any;
  serviceMethod: Object;
  job_report_client: any;
  job_subject_type: Object;
  subject_job_subject_type: any;

  var_service_outcome_name: any;
  var_location_status_name: any;
  var_location_status_found_name: any;
  var_exact_service_method_name: any;
  subjectAttemptPropertyType: any;
  var_property_type_name: any;
  var_time_service: any;

  // Text editor Settings
public simpleToolBar: object = {
  type: 'Expand',
  enableFloating: false,
  items: ['Bold', 'Italic', 'Underline', 'StrikeThrough',
  'FontName', 'FontSize', 'FontColor', 'BackgroundColor',
  'LowerCase', 'UpperCase', '|',
  'Formats', 'Alignments', 'OrderedList', 'UnorderedList',
  'Outdent', 'Indent', '|',
  'CreateLink', '|', 'ClearFormat', 'Print',
  'SourceCode', '|', 'Undo', 'Redo',
  // {
  //   tooltipText: 'Insert Promotion',
  //   undo: true,
  //   click: this.onClickPromotionButton.bind(this),
  //   template: '<button type="button" class="btn btn-default"><i class="fa fa-qrcode"></i></button>'
  // }
],
table: ['TableHeader', 'TableRows', 'TableColumns', 'TableCell', '-', 'BackgroundColor', 'TableRemove', 'TableCellVerticalAlign', 'Styles']
  };
  public pasteCleanupSettings: object = {
    prompt: true,
    plainText: false,
    keepFormat: false,
    deniedTags: ['a'],
    deniedAttrs: ['class', 'title', 'id'],
    allowedStyleProps: ['color', 'margin', 'font-size']
};  
  showPrevVersion_Field: any;
  set_general_notes: any;
  set_property_type_details_HTML: any;
  property_occupied_details_HTML: any;
  property_forsale_or_lease_sign_details_HTML: string;
  property_mail_details_HTML: any;
  property_vehicles_sighted_details_HTML: any;
  property_pets_details_HTML: any;
  property_occupancy_details_HTML: any;
  property_condition_HTML: any;
  attempts_notes_HTML: any;
  person_spoken_with_advised_HTML: any;
  vehicles_notes_HTML: any;
  neighbours_notes_HTML: any;
  calling_card_notes_HTML: any;
  postal_mail_notes_HTML: any;
  phone_call_notes_HTML: any;
  email_contents_HTML: any;
  subject_name: string;
  service_under_order_HTML: any;
  var_subject_attempt_type_name: any;
  confirm_details: number;
  subject_service_resolution_outcomes: any;
  subject_service_resolution_outcomes_by_type: any[] = [];
  resolutionOutcomeAnswersByType: any = {};


  allResolutions = [];

 constructor(
   private http: HttpClient, private _demoService: DemoService,
   private route: ActivatedRoute,
    vcr: ViewContainerRef, private router: Router,
    public HttpClient:HttpClient,
    private fileUploader: FileUploaderService,
    private _mysqlService: MysqlService,
    private modalService: BsModalService,
    public datepipe: DatePipe,
    public gfunc: GlobalFunctionsService,
    public toastr: HotToastService,
    private sanitizer: DomSanitizer,
    private clipboard: Clipboard, // ciipboard
    private legalDate: LegalDateTimeService,
 ) { 

  this.nav = document.querySelector('nav.navbar');
  // this.toastr.setRootViewContainerRef(vcr);

// login vars
// Set and Access login Session Variables
this.gfunc.setLoginSessionVars(); // set in a global function file
this.sessionUserId = this.gfunc.currentUserVAR.user_id;
this.sessionUsername = this.gfunc.currentUserVAR.username;
this.sessionBrandId = this.gfunc.currentUserVAR.brand_id;

   // need to add this as routes does not work globally
   this.all_router_details = this.router.url;
   this.gfunc.current_base_route = this.router.url.substr(0, this.all_router_details.lastIndexOf('/'));

   this.showNewAddress = false;	


    // DataUtil.serverTimezoneOffset = new Date().getTimezoneOffset()/60; 
    this.local_date_time = new Date(new Date().getTime());
    var offset = new Date().getTimezoneOffset();
    this.local_date_time_offset = offset;
    this.local_date_time_zone = Intl.DateTimeFormat().resolvedOptions().timeZone

    this.service_local_timezone = this.gfunc.getTimezoneName(); // this sets the current clients user timezone for the database.
    this.service_local_offset = new Date().getTimezoneOffset(); // this sets the current clients user timezone for the database.
    this.service_local = Intl.DateTimeFormat().resolvedOptions().timeZone

    this.confirm_details = 0;


 }

 // check for changes. to load data.
 ngOnChanges(changes) {

  //  this.model = new SubjectService();
  //  this.model = SubjectService;

  /// this.getJobPlaintiffTypes();
   if (changes.item_id) {
     // deal with asynchronous Observable result
   this.subject_service_id = changes.item_id.currentValue; // no dot value remember...
    // this.model.subject_contact_email_id = this.subject_contact_email_id;
     // this.getJob(this.job_id);
     
     this.getSubjectService(this.subject_service_id);
     this.show_paragraph = 1

   }
 }


 ngOnInit() {

 }

 // Functions

// :: All ?
 getSubjectService(subject_service_id) {
  this._demoService.getSubjectService(subject_service_id).subscribe(
     data => { this.subject_service = data;
      // this.subject_service_results = DataUtil.parse.parseJson(data);
      



   this.model = new SubjectService();
      
      let res = data[0];



      // new time addition
      this.model = res;
      this.normalizeTimeService24(this.model);


      // Automatically Set the Service as successful
            if(res.subject_attempt_type_id == 1){
        // this.model.subject_service_resolution_outcome_id = 1;
        // this.attemptForm.controls['subject_service_resolution_outcome_id'].setValue(1); // set the form value
        //  this.attemptForm.controls['subject_service_resolution_outcome_id'].patchValue(1);
      }



// Check if time_service is a Date or string, then normalize
        // if (res.time_service) {
        //   const dateObj = new Date(res.time_service);

        //   if (!isNaN(dateObj.getTime())) {
        //     const hours = dateObj.getHours().toString().padStart(2, '0');
        //     const minutes = dateObj.getMinutes().toString().padStart(2, '0');


        //     // Optional: for 12hr display
        //     const ampm = +hours >= 12 ? 'PM' : 'AM';
        //     const hour12 = ((+hours % 12) || 12).toString();

        //     // This goes into the input[type="time"]
        //     // this.model.time_service = `${hours}:${minutes}`;
        //     this.model.time_service = `${hour12}:${minutes} ${ampm}`;


        //     this.model.time_service_text = `${hour12}:${minutes} ${ampm}`;

        //     // this.attemptForm.controls['time_service'].setValue(this.model.time_service_text); // set the form value
        //     // this.attemptForm.controls['time_service_text'].setValue(this.model.time_service_text); // set the form value


        //   }
        // }




      this.service_local_timezone = res.service_local_timezone;

      // Run the job data queries.
      this.subject_id = res.subject_id;
     
      this.getJob(res.job_id); // get the owner_trace_code


   

      this.getServiceMethods();
      // this.getServiceOutcomes();
this.getServiceOutcomesAccessLevel(this.gfunc.sessionUserLevel)

      this.getSubjectRelationships();
      this.getExactServiceMethods();
  
      this.getSubjectAttemptTypes();
      this.getPropertyTypes();
      // this.model.date_service = this.mytime;
      // this.model.time_service = this.mytime;
  
     // this.model.who_service = this.sessionUserId;
     this.getSubjectAgentBrandsAssigned(this.subject_id);
     this.getJobSubject(this.subject_id);
     this.getSubjectLocationStatuss();
     this.getSubjectLocationStatussFound();
     // sets the label of attempt type on load for edit component.
     this.getSubjectAttemptType(res.subject_attempt_type_id);

     this.getSubjectContactEmails(this.subject_id);



      // load the subject array.
      if ( res.additional_subject >= 1) { 
     let new_model = {
      subject_array: JSON.parse(res.subject_array) // must be parsed
    }
    this.getJobSubjectsArray(new_model);
 }


  this.getSubjectServiceOutcomeTemplate_ResolutionOutcomes(res.ssot_id)

// Load the attached files from server_files_array
              // Count items of brand search to loop through
              // this.service_file_array = data[0].service_file_array;

              this.service_file_array = JSON.parse(data[0].service_file_array); // parse this first...!!!

              // console.log('this service file array: ', this.service_file_array)

              if ( this.service_file_array != null) {

              console.log('Service File Array: ' + JSON.stringify(this.service_file_array));
              // let  count_of_payment_items = Object.keys(this.service_file_array).length;
              let  count_of_payment_items = this.service_file_array.length;

              // now loop and push to join model
              for(let i=0;i < count_of_payment_items; i++) {
                let res2 = this.service_file_array[i];

                  // push to holding list of invoice items, all current subject_billing_items. (no filtering as yet.)
                  this.allAttachments.push({
                  //  ...this.service_file_array[i],
                   file_name: res2.file_name,
                   job_file: res2.job_file,
                   subject_file: res2.subject_file,
                   file_id: res2.file_id,
                   file_server_location: res2.file_server_location,
                   file_ext: res2.file_ext,
                   file_brand_id: res2.file_brand_id,
                   file_access_level: res2.file_access_level,
                   assigned_to_agents: res2.assigned_to_agents,
                   brand_type_id: res2.brand_type_id
                          });

              } // end brands loop.
              this.model.service_file_array = this.allAttachments;

              this.allAttachments = this.allAttachments;

              // parse the images array before we processs
              // this.service_file_array = JSON.parse(res.service_file_array);
              // this.model.property_images = JSON.parse(res.property_images);
              // this.model.property_sign_images = JSON.parse(res.property_sign_images);
              // this.model.property_mail_images = JSON.parse(res.property_mail_images);
              // this.model.property_vehicles_images = JSON.parse(res.property_vehicles_images);
              // this.model.property_pets_images = JSON.parse(res.property_pets_images);
              // this.model.property_occupancy_images = JSON.parse(res.property_occupancy_images);
              // this.model.property_type_images = res.property_type_images;
         
        // This function is very important and now pauses then load the document correctly.
                      //     setTimeout(() => {  
                      //       console.log("A Simple Pause!"); 
                      // console.log("Now Ready to load...")
                      //     }, 3000);


              let array = JSON.parse(data[0].property_type_images); // parse this first...!!!
              if ( array != null) {
              let array_count = array.length;
             // load and push the service image arrays (need to do this for each object of data.)
                      this.property_type_images = [];
                      // this.model.property_type_images = [];
                     for(let i=0;i < array_count; i++) {
                      let res2 = array[i];
                     this.property_type_images.push({ 
                      file_name: res2.file_name,
                      job_file: res2.job_file,
                      subject_file: res2.subject_file,
                      file_id: res2.file_id,
                      file_server_location: res2.file_server_location,
                      file_ext: res2.file_ext,
                      file_brand_id: res2.file_brand_id,
                      file_access_level: res2.file_access_level,
                      assigned_to_agents: res2.assigned_to_agents,
                      brand_type_id: res2.brand_type_id  
                      });
                     }
                     this.property_type_images = this.property_type_images;
                    //  this.model.property_type_images = this.property_type_images;
              };

              array = [];
              array = JSON.parse(data[0].property_images); // parse this first...!!!
              if ( array != null) {
              let array_count = array.length;
                   // load and push the service image arrays (need to do this for each object of data.)
                            this.property_images = [];
                            // this.model.property_images = [];
                           for(let i=0;i < array_count; i++) {
                            let res2 = array[i];
                           this.property_images.push({ 
                            file_name: res2.file_name,
                            job_file: res2.job_file,
                            subject_file: res2.subject_file,
                            file_id: res2.file_id,
                            file_server_location: res2.file_server_location,
                            file_ext: res2.file_ext,
                            file_brand_id: res2.file_brand_id,
                            file_access_level: res2.file_access_level,
                            assigned_to_agents: res2.assigned_to_agents,
                            brand_type_id: res2.brand_type_id  
                            });
                           }
                           this.property_images = this.property_images;
                          //  this.model.property_type_images = this.property_type_images;
               }

                          array = [];
                          array = JSON.parse(data[0].property_sign_images); // parse this first...!!!
                          if ( array != null) {
                          let array_count = array.length;
                               // load and push the service image arrays (need to do this for each object of data.)
                                        this.property_sign_images = [];
                                        // this.model.property_images = [];
                                       for(let i=0;i < array_count; i++) {
                                        let res2 = array[i];
                                       this.property_sign_images.push({ 
                                        file_name: res2.file_name,
                                        job_file: res2.job_file,
                                        subject_file: res2.subject_file,
                                        file_id: res2.file_id,
                                        file_server_location: res2.file_server_location,
                                        file_ext: res2.file_ext,
                                        file_brand_id: res2.file_brand_id,
                                        file_access_level: res2.file_access_level,
                                        assigned_to_agents: res2.assigned_to_agents,
                                        brand_type_id: res2.brand_type_id  
                                        });
                                       }
                                       this.property_sign_images = this.property_sign_images;
                          //  this.model.property_type_images = this.property_type_images;
                                      }

                          array = [];
                          array = JSON.parse(data[0].property_mail_images); // parse this first...!!!
                          if ( array != null) {
                          let array_count = array.length;
                                // load and push the service image arrays (need to do this for each object of data.)
                                        this.property_mail_images = [];
                                        // this.model.property_images = [];
                                        for(let i=0;i < array_count; i++) {
                                        let res2 = array[i];
                                        this.property_mail_images.push({ 
                                        file_name: res2.file_name,
                                        job_file: res2.job_file,
                                        subject_file: res2.subject_file,
                                        file_id: res2.file_id,
                                        file_server_location: res2.file_server_location,
                                        file_ext: res2.file_ext,
                                        file_brand_id: res2.file_brand_id,
                                        file_access_level: res2.file_access_level,
                                        assigned_to_agents: res2.assigned_to_agents,
                                        brand_type_id: res2.brand_type_id  
                                        });
                                        }
                                        this.property_mail_images = this.property_mail_images;
                                        //  this.model.property_type_images = this.property_type_images;
                                      }

                            array = [];
                            array = JSON.parse(data[0].property_vehicles_images); // parse this first...!!!
                            if ( array != null) {
                            let array_count = array.length;
                                  // load and push the service image arrays (need to do this for each object of data.)
                                          this.property_vehicles_images = [];
                                          // this.model.property_images = [];
                                          for(let i=0;i < array_count; i++) {
                                          let res2 = array[i];
                                          this.property_vehicles_images.push({ 
                                          file_name: res2.file_name,
                                          job_file: res2.job_file,
                                          subject_file: res2.subject_file,
                                          file_id: res2.file_id,
                                          file_server_location: res2.file_server_location,
                                          file_ext: res2.file_ext,
                                          file_brand_id: res2.file_brand_id,
                                          file_access_level: res2.file_access_level,
                                          assigned_to_agents: res2.assigned_to_agents,
                                          brand_type_id: res2.brand_type_id  
                                          });
                                          }
                                          this.property_vehicles_images = this.property_vehicles_images;
                                        //  this.model.property_type_images = this.property_type_images;
                            }

                            array = [];
                            array = JSON.parse(data[0].property_pets_images); // parse this first...!!!
                            if ( array != null) {
                            let array_count = array.length;
                                  // load and push the service image arrays (need to do this for each object of data.)
                                          this.property_pets_images = [];
                                          // this.model.property_images = [];
                                          for(let i=0;i < array_count; i++) {
                                          let res2 = array[i];
                                          this.property_pets_images.push({ 
                                          file_name: res2.file_name,
                                          job_file: res2.job_file,
                                          subject_file: res2.subject_file,
                                          file_id: res2.file_id,
                                          file_server_location: res2.file_server_location,
                                          file_ext: res2.file_ext,
                                          file_brand_id: res2.file_brand_id,
                                          file_access_level: res2.file_access_level,
                                          assigned_to_agents: res2.assigned_to_agents,
                                          brand_type_id: res2.brand_type_id  
                                          });
                                          }
                                          this.property_pets_images = this.property_pets_images;
                                        //  this.model.property_type_images = this.property_type_images;
                            }
                            array = [];
                            array = JSON.parse(data[0].property_occupancy_images); // parse this first...!!!
                            if ( array != null) {
                            let array_count = array.length;
                                  // load and push the service image arrays (need to do this for each object of data.)
                                          this.property_occupancy_images = [];
                                          // this.model.property_images = [];
                                          for(let i=0;i < array_count; i++) {
                                          let res2 = array[i];
                                          this.property_occupancy_images.push({ 
                                          file_name: res2.file_name,
                                          job_file: res2.job_file,
                                          subject_file: res2.subject_file,
                                          file_id: res2.file_id,
                                          file_server_location: res2.file_server_location,
                                          file_ext: res2.file_ext,
                                          file_brand_id: res2.file_brand_id,
                                          file_access_level: res2.file_access_level,
                                          assigned_to_agents: res2.assigned_to_agents,
                                          brand_type_id: res2.brand_type_id  
                                          });
                                          }
                                          this.property_occupancy_images = this.property_occupancy_images;
                            //  this.model.property_type_images = this.property_type_images;
                                        }
                            array = [];
                            array = JSON.parse(data[0].property_condition_images); // parse this first...!!!
                            if ( array != null) {
                            let array_count = array.length;
                                  // load and push the service image arrays (need to do this for each object of data.)
                                          this.property_condition_images = [];
                                          // this.model.property_images = [];
                                          for(let i=0;i < array_count; i++) {
                                          let res2 = array[i];
                                          this.property_condition_images.push({ 
                                          file_name: res2.file_name,
                                          job_file: res2.job_file,
                                          subject_file: res2.subject_file,
                                          file_id: res2.file_id,
                                          file_server_location: res2.file_server_location,
                                          file_ext: res2.file_ext,
                                          file_brand_id: res2.file_brand_id,
                                          file_access_level: res2.file_access_level,
                                          assigned_to_agents: res2.assigned_to_agents,
                                          brand_type_id: res2.brand_type_id  
                                          });
                                          }
                                          this.property_condition_images = this.property_condition_images;
                                        //  this.model.property_type_images = this.property_type_images;
                            }
            

            }



    },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
 }


 editSubjectContactEmail(model) {
  // model.subject_id = this.subject_id;
 this._demoService.editSubjectContactEmail(model).subscribe(
   data => { 
    //  this.toastr.info('Subject Contact Email Updated');
     this.closeParentModel.emit();
   },
   err => console.error(err),
   // () => console.log('done loading Trace Types')
 );

}



 addSubjectContactEmail(model) {
   // model.subject_id = this.subject_id;
  this._demoService.createSubjectContactEmail(model).subscribe(
    data => { 
      // this.toastr.info('Subject Contact Email Added');
      this.closeParentModel.emit();
    },
    err => console.error(err),
    // () => console.log('done loading Trace Types')
  );

 }



 getJob(job_id) {
 this._demoService.getJobID(job_id).subscribe(
    data => { this.job = data;
     let res = data[0];
     // Run the job data queries.
     this.client_reference = res.owner_trace_code;
     this.owner_trace_code = res.owner_trace_code;

     this.job_model = DataUtil.parse.parseJson(res);



   },
    err => console.error(err),
    // () => console.log('done loading Trace Types')
  );
}




getJobSubject(subject_id) {
  this._demoService.getJobSubject(subject_id).subscribe(
     data => { this.current_subject = data;
      const res = data[0];

      this.subject_model = DataUtil.parse.parseJson(res);

        // set for notice and log
        let subject_name = res.first_name + '' + res.surname;
        let subject_business_name = res.business_name;
        
                if(subject_business_name != ''){
                      subject_name = subject_business_name;
                  }
          this.subject_name = subject_name;


    },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
 }



  // created so ensure paragraph renders before submission
confirmDetailsBeforeSubmit(confirm_details){
  this.confirm_details = confirm_details;
}



// gets the list of users assiciated for drop down.
getBrandUsers(brand_id) {
  this._demoService.getBrandUsers(brand_id).subscribe(
     data => { this.staffList = data;
    },
     err => console.error(err),
     () => console.log('Candidates Loaded.')
   );
 }


 getSubjectAgentAssigned(subject_id) {
  this._demoService.getSubjectAgentsAssigned(subject_id).subscribe(
     data => { this.assignedList = data;
    },
     err => console.error(err),
     // () => console.log('Loaded Assigned Agents Loaded.')
   );
 }


 getSubjectAgentBrandsAssigned(subject_id) {
  this._demoService.getSubjectAgentBrandsAssigned(subject_id).subscribe(
     data => { this.assignedBrandList = data;
    },
     err => console.error(err),
     // () => console.log('Loaded Assigned Agents Loaded.')
   );
 }



 getSubjectAttemptType(subject_service_type_id) {
  this._demoService.getSubjectAttemptType(subject_service_type_id).subscribe(
    data => { this.subjectAttemptType = data;
    let res = data[0]
    this.subject_attempt_type_label = res.subject_attempt_type_name;
    },
    err => console.error(err),
  );
  }


 getSubjectAttemptTypes() {
  this._demoService.getSubjectAttemptTypes().subscribe(
    data => { this.subjectAttemptTypesList = data; },
    err => console.error(err),
  );
  }

 getServiceOutcomes() {
  this._demoService.getServiceOutcomes().subscribe(
    data => { this.serviceOutcomes = data; },
    err => console.error(err),
  );
  }


  getServiceOutcomesAccessLevel(access_level) {
    this._demoService.getServiceOutcomesAccessLevel(access_level).subscribe(
      data => { this.serviceOutcomes = data; 
      },
      err => console.error(err),
    );
    }


    
onTimeChange(model){

            // this.toastr.info('changes cumin')
            
            //       // need to set the txt....?? --- ADDED TIME ZONE [140824_b]
            //       const dateTime = new Date(model.time_service).toLocaleTimeString('en-AU', {
            //         hour: 'numeric', minute: 'numeric', hour12: true, timeZone: model.service_local
            //         });
              
              
            //       // this.model.time_service_text = this.mytime;
            //           this.model.time_service_text = dateTime;
            //           model.time_service_text = dateTime;
  };
  

 getServiceMethods() {
  this._demoService.getServiceMethodsMenu().subscribe(
    data => { this.serviceMethods = data; },
    err => console.error(err),
  );
  }


  getSubjectRelationships() {
    this._demoService.getSubjectRelationships().subscribe(
      data => { this.subjectRelationships = data; },
      err => console.error(err),
    );
    }

    getExactServiceMethods() {
      this._demoService.getExactServiceMethods().subscribe(
        data => { this.exactServiceMethods = data; },
        err => console.error(err),
      );
      }


      createSubjectService(model) {
        this.model.subject_id = this.subject_id;
        this.model.job_id = this.job_id;
        this.model.created_by = this.sessionUserId;
        this.prepareResolutionOutcomeAnswers(model);
        this._demoService.createSubjectService(model).subscribe(
             data => {  this.get_latest_subject_service_id = data; // this is the retuned json upon creation.
              // this.getTraceCandidateNotes(this.trace_candidate_id);
      
             // CreateJob3Component.getTraceCandidateNotes();
      
             // CreateJob3Component.returned.next(false);
              // this.toastr.info('Service Entered!');
              this.getSubjectServices(this.subject_id);

        this.router.navigateByUrl('admin/clients', {skipLocationChange: true}).then(() =>
        this.router.navigate(['admin/jobs/subject/edit/' + model.subject_id + '']));
              
              
              /// Did not worke.
              // refresh the imported subject component
              // SubjectEditComponent.returned.next(false);

               //  return true;
             },
             error => {
              console.log(error(error));
               // return Observable.throw(error);
             }
        );
        }


        getSubjectServices(subject_id) {
          this._demoService.getSubjectServices(subject_id).subscribe(
            data => { this.subject_services = data;
             // console.log("Done loadng USER");
             // console.log(this.users);
             let res = data[0];
             // this.getSubjectServiceOutcome(res.subject_service_outcome_id);
             // this.getUsersById(res.who_attended);
            },
            error => {
            //  console.error('Error Loading User!');
            // return Observable.throw(error);
            }
          ); }



          deleteSubjectService(subject_service_id) {
            if (confirm('Are you sure you want to delete this Service Information? ')) {
              this._demoService.deleteSubjectService(subject_service_id).subscribe(
                 data => {
                  this.getSubjectServices(this.subject_id);
                   return true;
                 },
                 error => {
                   console.error('Error deleting Attendence!');
                  return console.log(error);
                 }
              );
          }
          }



          
          getSubjectServiceOutcome(subject_service_outcome_id) {
            this._demoService.getSubjectServiceOutcome(subject_service_outcome_id).subscribe(
              data => { this.subjectServiceOutcome = data;
              let res = data[0];
              this.is_count_subject_service_outcome_lookup = res.is_count
              
              },
              err => console.error(err),
            );
            } 

            getSubjectServiceOutcomeIsCount(subject_service_outcome_id) {
              this._demoService.getSubjectServiceOutcome(subject_service_outcome_id).subscribe(
                data => { this.subjectServiceOutcome = data;
                let res = data[0];
                this.is_count_subject_service_outcome_lookup = res.is_count;
                this.is_count = this.is_count_subject_service_outcome_lookup; // sets the is_count_same as drop down.
                
                },
                err => console.error(err),
              );
              } 

            getSubjectLocationStatuss() {
              this._demoService.SubjectLocationStatuss().subscribe(
                data => { this.subjectLocationStatuss = data; },
                err => console.error(err),
              );
              }

              getSubjectLocationStatussFound() {
                this._demoService.SubjectLocationStatussFound().subscribe(
                  data => { this.subjectLocationStatussFound = data; },
                  err => console.error(err),
                );
                }

                // for select items
                onSelectionChange(entry, model): void {
                 // this.selectedEntry = entry;
                 console.log('selection change: ' + entry);
                 this.model.subject_location_status_found_id = entry; // changes or updates via selection of radio button group
                //  model.subject_location_status_found_id = entry; // changes or updates via selection of radio button group
                this.attemptForm.controls['subject_location_status_found_id'].setValue(entry);
                  
                  // this.model.subject_location_status_found_id = entry; // changes or updates via selection of radio button group
                  // this.model.subject_location_status_found_name = entry;
                  // this.model.subject_location_status_found_name = entry;
                }


                // for select items
                onSelectionChangeVehicles(entry) {
                // this.selectedEntry = entry;
                this.model.vehicles = entry; // changes or updates via selection of radio button group
               // this.model.vehicles_notes = 'here are my notes.'
              }
              // for select items
              onSelectionChangeNeighbours(entry) {
                // this.selectedEntry = entry;
                  this.model.neighbours = entry; // changes or updates via selection of radio button group
                }
                onSelectionChangeCallingCard(entry) {
                  // this.selectedEntry = entry;
                    this.model.calling_card = entry; // changes or updates via selection of radio button group
                  };
                  onSelectionChangeMail(entry) {
                    // this.selectedEntry = entry;
                      this.model.postal_mail = entry; // changes or updates via selection of radio button group
                    }
                    onSelectionChangePhoneCall(entry) {
                      // this.selectedEntry = entry;
                        this.model.phone_call = entry; // changes or updates via selection of radio button group
                      }
                      onSelectionChangeAttempts(entry) {
                        // this.selectedEntry = entry;
                          this.model.attempts = entry; // changes or updates via selection of radio button group
                        }
                        onSelectionChangePersonType(entry) {
                          // this.selectedEntry = entry;
                            this.model.person_type = entry; // changes or updates via selection of radio button group
                          }
                


                          clearChecked(field, model){
                           model.vehicles = false;
                           model.vehicles_notes = null;
                          // this.attemptForm.controls['radiogroup2'].setValue(null);
                          // this.attemptForm.setValue({radiogroup2: '', radiogroup3: true});
                          }
                          clearCheckedNeighbours(field, model){ model.neighbours = false; model.neighbours_notes = null;}
                          clearCheckedCallingCard(model){ model.calling_card = false; model.calling_card_notes = null;}
                          clearCheckedPostalMail(model){ model.postal_mail = false; model.mail_notes = null;}
                          clearCheckedPhoneCall(model){ model.phone_call = false; model.phone_call_notes = null;}
                          clearCheckedAttempts(model){ model.attempts = false; model.attempts_notes = null;}
                          clearCheckedPersonType(model){ model.person_type = false; model.person_type_notes = null;}
                          clearCheckedResolutions(model){
                            model.subject_service_resolution_outcome_id = null;
                            model.subject_service_resolution_outcome_type_answer_array = null;
                            this.resolutionOutcomeAnswersByType = {};
                          }

                          toggleSection(id: string) {
                            this.sections[id] = !this.isSectionOpen(id);
                          }

                          confirmOptionalFieldsToggle(isOpen: boolean, label: string): boolean {
                            const message = isOpen
                              ? `Hide ${label} and mark the fields below as not applicable for this edit?`
                              : `Show ${label}. You will need to complete the relevant fields below for this edit.`;

                            return confirm(message);
                          }

                          toggleSectionWithConfirm(id: string, label: string) {
                            if (!this.confirmOptionalFieldsToggle(this.isSectionOpen(id), label)) {
                              return;
                            }

                            this.toggleSection(id);
                          }

                          isSectionOpen(id: string): boolean {
                            return this.sections[id] !== false;
                          }

                          isSectionSkipped(id: string): boolean {
                            return this.sections[id] === false;
                          }

                          isGeneralNotesRequired(): boolean {
                            return this.model?.subject_service_outcome_id >= 8
                              && (
                                this.isSectionSkipped('section29')
                                || this.isSectionSkipped('occupancy_11_12')
                              );
                          }

                          getButtonLabel(id: string, label: string): string {
                            return this.isSectionOpen(id) ? `Hide ${label}` : `Show ${label}`;
                          }


                // for select items
                onChangeServiceCount(model) {
                  this.model.service_number = 0;   
                  model.job_id = this.job_id;
                  model.subject_id = this.subject_id;
                 // look (count) up job_id, subject_id, agent id attendences + 1
                 this.getJobSubjectAttendancesCountNumber(model);
                // set model.service_number = results.
                

                 }


                 getJobSubjectAttendancesCountNumber(model){
                  this._demoService.getJobSubjectAttendancesCountNumber(model).subscribe(
                    data => { this.current_service_number = data; 
                      this.converted_service_number = Number(this.current_service_number);
                                        // this.selectedEntry = entry;
                  let increment = Number(this.converted_service_number + 1);
                  this.model.service_number = increment; // changes or updates via selection of radio button group

                    console.log(data);
                    },
                    err => {console.error(err)
                      // set to one if there is an error because it means subject id cannot be found
                      this.model.service_number = 1;
                    },
                  );

                 }


// :: Attempts - 2022 Upgrades

                 //:: Set the label for all naming conventions
setAttemptType(model) {
    this.subject_attempt_type_label = (<HTMLSelectElement>document.getElementById('subject_attempt_type_id')).selectedOptions[0].text;
    console.log('Attempt Type Task: ' +  this.subject_attempt_type_label);
  //  const doc_name = document.getElementById('doc_name').innerText;
  //  console.log('Document Name: ' +  doc_name);

  // :: Set Some Defaults
  // Attempt - Servive
  if(model.subject_attempt_type_id == 1 ){
    this.model.subject_service_outcome_id = 1; // outcome default is served.
    this.attemptForm.controls['subject_service_outcome_id'].setValue('1');
    this.is_count = 1; //always count if  a succesful served.
  }

}



// pull the selected attempt Outcome drop down name.
setOutcomeType(model) {
  this.subject_outcome_type_label = (<HTMLSelectElement>document.getElementById('subject_service_outcome_id')).selectedOptions[0].text;
  console.log('Outcome Type Task: ' +  this.subject_outcome_type_label);

// need to look up if current outcome needs to be counted and set is_count = 1 / true.
this.getSubjectServiceOutcomeIsCount(model.subject_service_outcome_id);

}

editSubjectService(model){

  // this.LoadSubjectserviceOutcomeTemplateParagraph(model) // save the paragraph // render just in case....

  model.service_file_array = JSON.stringify(this.allAttachments); // sets sthe model.
  model.property_images = JSON.stringify(this.property_images); // sets sthe model.
  model.property_sign_images = JSON.stringify(this.property_sign_images); // sets sthe model.
  model.property_sign_images = JSON.stringify(this.property_sign_images); // sets sthe model.
  model.property_mail_images = JSON.stringify(this.property_mail_images); // sets sthe model.
  model.property_vehicles_images = JSON.stringify(this.property_vehicles_images); // sets sthe model.
  model.property_pets_images = JSON.stringify(this.property_pets_images); // sets sthe model.
  model.property_occupancy_images = JSON.stringify(this.property_occupancy_images); // sets sthe model.
  model.property_condition_images = JSON.stringify(this.property_condition_images); // sets sthe model.
  model.property_type_images = JSON.stringify(this.property_type_images); // sets sthe model.

  let subject_name = model.first_name + '' + model.surname;
  let subject_business_name = model.business_name;
  
          if(subject_business_name != '') {
                subject_name = subject_business_name;
            }
    model.subject_name = subject_name;

model.owner_trace_code = this.owner_trace_code;
this.prepareResolutionOutcomeAnswers(model);






// moved... to below...

      



  this._demoService.editSubjectService(model).subscribe(
    data => { // this.current_subject = data;

 

      this.gfunc.insertLog_UpdateSubjectAttempt(model);


      // add two now log types for tracking and leave automations to attempt_added.
       //subject_attendance_added
       if(model.subject_attempt_type_id == 1 ){
         this.gfunc.insertLog_UpdateSubjectAttempt_Service(model);
         }
         //subject_service_added
         if(model.subject_attempt_type_id == 2 ){
           this.gfunc.insertLog_UpdateSubjectAttempt_Attendance(model);
         }




    // const res = data[0];
    // this.toastr.success('Attempt Details Updated');
     this.closeParentModel.emit();
   },
    err => console.error(err),
    // () => console.log('done loading Trace Types')
  );
}


setEmailAddressServed(model) {
  this.email_address_served = (<HTMLSelectElement>document.getElementById('subject_contact_email_id')).selectedOptions[0].text;
  console.log('Email Selected: ' +  this.email_address_served);

// only set if not the descriptor.
  if (this.email_address_served != '-- choose or enter --') {
  model.email_address_served = this.email_address_served; // sets the field so it can be entered or selected
  this.model.email_address_served = this.email_address_served; // sets the field so it can be entered or selected
  }else {
    this.model.email_address_served = null;
  }

  //  const doc_name = document.getElementById('doc_name').innerText;
//  console.log('Document Name: ' +  doc_name);
}



getSubjectContactEmails(subject_id) {
  this._demoService.getSubjectContactEmails(subject_id).subscribe(
     data => { this.subject_contact_emails = data; 
    let res = data[0];
     // this.model.email_address_served = res.subject_contact_email_address; // sets from drop down
    },
     err => console.error(err),
      () => {
        console.log('done loading SR');
                    }
        );
 }



        //  onAdd(data) {
        //   // if (confirm('Are you sure you want to Attatch this file? ')) {
        //    // this.selectedFeatures.push(fileName);
        //     // push to global array

        // console.log('Send Subject ID: ' + data.file_subject_id + ' JObID: ' + data.file_job_id);

        //                   if (data.file_subject_id  >= 1) {
        //                     this.set_job_file = 0;
        //                     this.set_subject_file = 1;
        //                   }

        //                   if (data.file_subject_id  <= 0) {
        //                     this.set_job_file = 1;
        //                     this.set_subject_file = 0;
        //                   }

        //                   // this.allAttachedFiles.push(data.fileName);
        //                   this.allAttachments.push({
        //                     file_name: data.full_file_name,
        //                     job_file: this.set_job_file,
        //                     subject_file: this.set_subject_file,
        //                     file_id: data.file_id,
        //                     file_server_location: data.file_server_location,
        //                     file_ext: data.file_ext,
        //                     file_brand_id: data.file_brand_id,
        //                     file_access_level: data.file_access_level,
        //                     assigned_to_agents: data.assigned_to_agents,
        //                     brand_type_id: data.brand_type_id
        //                   });

        //               this.allAttachments = this.allAttachments;
        //               this.model.service_file_array = this.allAttachments; // sets sthe model.
                      

        //               // this.model.allAttachedFiles = this.allAttachedFiles;
        //               // this.model.allAttachments = this.allAttachments;

        // // this.toastr.success('File Attached to Attempt.');
        //    // this.isShow = !this.isShow; // hides the div again
        //     // this.isShow_uploaded = !this.isShow_uploaded;

        //     // closes the model when opened from file browser.
        //     // this.modalRef.hide();
        //   // }
        // }





        onAdd(data) {
          // if (confirm('Are you sure you want to Attatch this file? ')) {
           // this.selectedFeatures.push(fileName);
            // push to global array
        
            // it must be an object sent - this now works as set from an attempt upload skipping across two components
        if(data.file_job_id == null){
          data = data[0];
        }
        
        // else leave as is from the button grid object with "index"
        
        
        console.log('Passed Data: ', JSON.stringify(data));
        // let data2 = data[0];
        // console.log('Send Subject ID: ' + data2.file_subject_id + ' JObID: ' + data2.file_job_id);
        
        console.log('Send Subject ID: ' + data.file_subject_id + ' JObID: ' + data.file_job_id);
        
                          if (data.file_subject_id  >= 1) {
                            this.set_job_file = 0;
                            this.set_subject_file = 1;
                          }
        
                          if (data.file_subject_id  <= 0) {
                            this.set_job_file = 1;
                            this.set_subject_file = 0;
                          }
        
                          // this.allAttachedFiles.push(data.fileName);
                          this.allAttachments.push({
                            file_name: data.full_file_name,
                            job_file: this.set_job_file,
                            subject_file: this.set_subject_file,
                            file_id: data.file_id,
                            file_server_location: data.file_server_location,
                            file_ext: data.file_ext,
                            file_brand_id: data.file_brand_id,
                            file_access_level: data.file_access_level,
                            assigned_to_agents: data.assigned_to_agents, // needs to be converted to json to work when saving in full attempt  array
                            // assigned_to_agents: '[]',
                            brand_type_id: data.brand_type_id
                          });
        
                      this.allAttachments = this.allAttachments;
                      this.model.service_file_array = this.allAttachments; // sets sthe model.
        
                      // this.model.allAttachedFiles = this.allAttachedFiles;
                      // this.model.allAttachments = this.allAttachments;
        
                      this.toastr.success('File Attached ;)');
        
        
        // mame of the array varairable
        if (data.attach_file_array_name == 'property_images'){
         console.log('attached_file_array_name: ', data.attach_file_array_name);
         
          this.property_images.push({
                        file_name: data.full_file_name,
                        job_file: this.set_job_file,
                        subject_file: this.set_subject_file,
                        file_id: data.file_id,
                        file_server_location: data.file_server_location,
                        file_ext: data.file_ext,
                        file_brand_id: data.file_brand_id,
                        file_access_level: data.file_access_level,
                        assigned_to_agents: data.assigned_to_agents,
                        // assigned_to_agents: '[]',
                        brand_type_id: data.brand_type_id
                      });
                      this.property_images = this.property_images;
                      this.model.property_images = this.property_images; // sets sthe model.
                 };
        
        
        // mame of the array varairable
        if (data.attach_file_array_name == 'property_sign_images'){
          // console.log('attached_file_array_name: ', data.attach_file_array_name);
           this.property_sign_images.push({
                         file_name: data.full_file_name,
                         job_file: this.set_job_file,
                         subject_file: this.set_subject_file,
                         file_id: data.file_id,
                         file_server_location: data.file_server_location,
                         file_ext: data.file_ext,
                         file_brand_id: data.file_brand_id,
                         file_access_level: data.file_access_level,
                         assigned_to_agents: data.assigned_to_agents,
                        // assigned_to_agents: '[]',
                         brand_type_id: data.brand_type_id
                       });
                       this.property_sign_images = this.property_sign_images;
                       this.model.property_sign_images = this.property_sign_images; // sets sthe model.
                  };         
        if (data.attach_file_array_name == 'property_mail_images'){
          // console.log('attached_file_array_name: ', data.attach_file_array_name);
            this.property_mail_images.push({
                          file_name: data.full_file_name,
                          job_file: this.set_job_file,
                          subject_file: this.set_subject_file,
                          file_id: data.file_id,
                          file_server_location: data.file_server_location,
                          file_ext: data.file_ext,
                          file_brand_id: data.file_brand_id,
                          file_access_level: data.file_access_level,
                          assigned_to_agents: data.assigned_to_agents,
                          // assigned_to_agents: '[]',
                          brand_type_id: data.brand_type_id
                        });
                        this.property_mail_images = this.property_mail_images;
                        this.model.property_mail_images = this.property_mail_images; // sets sthe model.
                  };
        if (data.attach_file_array_name == 'property_vehicles_images'){
          // console.log('attached_file_array_name: ', data.attach_file_array_name);

            this.property_vehicles_images.push({
                          file_name: data.full_file_name,
                          job_file: this.set_job_file,
                          subject_file: this.set_subject_file,
                          file_id: data.file_id,
                          file_server_location: data.file_server_location,
                          file_ext: data.file_ext,
                          file_brand_id: data.file_brand_id,
                          file_access_level: data.file_access_level,
                          assigned_to_agents: data.assigned_to_agents,
                          brand_type_id: data.brand_type_id
                        });
                        this.property_vehicles_images = this.property_vehicles_images;
                        this.model.property_vehicles_images = this.property_vehicles_images; // sets sthe model.
                  };                   
        if (data.attach_file_array_name == 'property_pets_images'){
          // console.log('attached_file_array_name: ', data.attach_file_array_name);
            this.property_pets_images.push({
                          file_name: data.full_file_name,
                          job_file: this.set_job_file,
                          subject_file: this.set_subject_file,
                          file_id: data.file_id,
                          file_server_location: data.file_server_location,
                          file_ext: data.file_ext,
                          file_brand_id: data.file_brand_id,
                          file_access_level: data.file_access_level,
                          assigned_to_agents: data.assigned_to_agents,
                          // assigned_to_agents: '[]',
                          brand_type_id: data.brand_type_id
                        });
                        this.property_pets_images = this.property_pets_images;
                        this.model.property_pets_images = this.property_pets_images; // sets sthe model.
                  };                   
        if (data.attach_file_array_name == 'property_occupancy_images'){
          // console.log('attached_file_array_name: ', data.attach_file_array_name);
            this.property_occupancy_images.push({
                          file_name: data.full_file_name,
                          job_file: this.set_job_file,
                          subject_file: this.set_subject_file,
                          file_id: data.file_id,
                          file_server_location: data.file_server_location,
                          file_ext: data.file_ext,
                          file_brand_id: data.file_brand_id,
                          file_access_level: data.file_access_level,
                          assigned_to_agents: data.assigned_to_agents,
                          // assigned_to_agents: '[]',
                          brand_type_id: data.brand_type_id
                        });
                        this.property_occupancy_images = this.property_occupancy_images;
                        this.model.property_occupancy_images = this.property_occupancy_images; // sets sthe model.
        };          
        if (data.attach_file_array_name == 'property_condition_images'){
          // console.log('attached_file_array_name: ', data.attach_file_array_name);
            this.property_condition_images.push({
                          file_name: data.full_file_name,
                          job_file: this.set_job_file,
                          subject_file: this.set_subject_file,
                          file_id: data.file_id,
                          file_server_location: data.file_server_location,
                          file_ext: data.file_ext,
                          file_brand_id: data.file_brand_id,
                          file_access_level: data.file_access_level,
                          assigned_to_agents: data.assigned_to_agents,
                          // assigned_to_agents: '[]',
                          brand_type_id: data.brand_type_id
                        });
                        this.property_condition_images = this.property_condition_images;
                        this.model.property_condition_images = this.property_condition_images; // sets sthe model.
        };
        if (data.attach_file_array_name == 'property_type_images'){
          // console.log('attached_file_array_name: ', data.attach_file_array_name);
           this.property_type_images.push({
                         file_name: data.full_file_name,
                         job_file: this.set_job_file,
                         subject_file: this.set_subject_file,
                         file_id: data.file_id,
                         file_server_location: data.file_server_location,
                         file_ext: data.file_ext,
                         file_brand_id: data.file_brand_id,
                         file_access_level: data.file_access_level,
                         assigned_to_agents: data.assigned_to_agents,
                        // assigned_to_agents: '[]',
                         brand_type_id: data.brand_type_id
                       });
                       this.property_type_images = this.property_type_images;
                       this.model.property_type_images = this.property_type_images; // sets sthe model.
                  };     
        
        
        // this.toastr.success('File Attached to Attempt.');
           // this.isShow = !this.isShow; // hides the div again
            // this.isShow_uploaded = !this.isShow_uploaded;
        
            // closes the model when opened from file browser.
            // this.modalRef.hide();
          // }
        }
        


RemoveElementFromAllEmailRecipients(key: number) {
  // removes agents
  // this.allEmailRecipients.forEach((value, index) => {
  //   if (value.brand_id === key) {
  //     this.allEmailRecipients.splice(index, 1);
  //   }
  // });
  // // removes clients Report
  // this.allClientEmailRecipients.forEach((value, index) => {
  //   if (value.brand_id === key) {
  //     this.allClientEmailRecipients.splice(index, 1);
  //   }
  // });
  // // removes clients Invoice
  // this.allClientInvoiceEmailRecipients.forEach((value, index) => {
  //   if (value.brand_id === key) {
  //     this.allClientInvoiceEmailRecipients.splice(index, 1);
  //   }
  // });
  // // removes Login Users
  // this.allLoginEmailRecipients.forEach((value, index) => {
  //   if (value.user_id === key) {
  //     this.allLoginEmailRecipients.splice(index, 1);
  //   }
  // });

  // removes all attachments
  this.allAttachments.forEach((value, index) => {
    if (value.file_name === key) {
      this.allAttachments.splice(index, 1);
    }
  });
}

setPhoneNumber(model) {
  this.phone_number = (<HTMLSelectElement>document.getElementById('subject_contact_number_id')).selectedOptions[0].text;
  console.log('Phone Number Selected: ' +  this.phone_number);

// only set if not the descriptor.
  if (this.phone_number != '-- choose or enter --') {
  this.model.phone_number = this.phone_number; // sets the field so it can be entered or selected
  }else {
    this.model.phone_number = null;
  }

  //  const doc_name = document.getElementById('doc_name').innerText;
//  console.log('Document Name: ' +  doc_name);
}

getSubjectContactNumbers(subject_id) {
  this._demoService.getSubjectContactNumbers(subject_id).subscribe(
     data => { this.subject_contact_numbers = data; },
     err => console.error(err),
      () => {
        console.log('done loading SCN');
                    }
        );
 }





 RemoveElementFromAllRecipients_Parent(key: number) {
  // removes agents
  // this.allEmailRecipients.forEach((value, index) => {
  //   if (value.brand_id === key) {
  //     this.allEmailRecipients.splice(index, 1);
  //   }
  // });
  // // removes clients Report
  // this.allClientEmailRecipients.forEach((value, index) => {
  //   if (value.brand_id === key) {
  //     this.allClientEmailRecipients.splice(index, 1);
  //   }
  // });
  // // removes clients Invoice
  // this.allClientInvoiceEmailRecipients.forEach((value, index) => {
  //   if (value.brand_id === key) {
  //     this.allClientInvoiceEmailRecipients.splice(index, 1);
  //   }
  // });
  // // removes Login Users
  // this.allLoginEmailRecipients.forEach((value, index) => {
  //   if (value.user_id === key) {
  //     this.allLoginEmailRecipients.splice(index, 1);
  //   }
  // });

  // removes all attachments
  this.allAttachments.forEach((value, index) => {
    if (value.file_name === key) {
      this.allAttachments.splice(index, 1);
      this.toastr.success('File Attachment cleared.')
    }
  });
}

 // MODAL
// start of modal windows service as a template
openModal(template: TemplateRef<any>) {
  const config = { backdrop: true, ignoreBackdropClick: true, class: 'gray modal-lg' };
  this.modalRef = this.modalService.show(template, config);
 }
 
 getPropertyTypes() {
  this._demoService.getPropertyTypes().subscribe(
    data => { this.propertyTypesList = data; },
    err => console.error(err),
  );
  }








  addAutomationFromModal(model, system_automation_id) {
    // alert('parent component function.');
   // this.modalService.hide(1); - removed the scroll bard do not use!!!
    // this.modalRef.hide();
   // this.getJobPlaintiffs(this.job_id);
   // this.refreshGrid(); // resets the grid if updated and closed.
  //  this.updateTypeClick = false; // closes the div
  // :: reset the entire page.
  // this.gfunc.globalJobSubjectViewSkipRoute(this.subject_id);
  
  // this.allRecipients.push({
  //   recipient_name: model.recipient_name + ' - ' + model.recipient_type_name,
  //   recipient_email_address: model.recipient_email_address,
  //   recipient_brand_id: null,
  //   recipient_brand_type_id: null,
  //   recipient_user_id: null,
  //   recipient_user_level_id: null,
  //   recipient_type_name: model.recipient_type_name,
  //   model.system_automation_id,
  // });
  
  this.allAutomations.push(
    system_automation_id
  );
  
  this.allAutomations = this.allAutomations;
  // this.model.system_automation_array = this.allAutomtaions;
  
  // simple small updated - quick and then refresh the page
  // this.model.system_automation_array = JSON.stringify(this.allAutomtaions);
  // this.model.log_type_id = this.log_type_id;
  
  this.form.controls['subject_array'].patchValue(JSON.stringify(this.allAutomations)); // works by setting the new frorm value from parent modal.
  // prbably dont need any of this below.
  
  // rest the list
  // system_automation_array: this.allAutomations,
  let new_model = {
    subject_array: this.allAutomations
  }
  this.getJobSubjectsArray(new_model);
  
  
  // model.allRecipients = this.allRecipients;
  
  // this.model.system_automation_array.push(
  //   system_automation_id
  // )
  // this.model.system_automation_array = this.allAutomtaions;
  // this.updateSystemLogType(model);
  // this.getSystemLogType(this.log_type_id);
  
  this.modalRef.hide();
  // console.log('Added External Recipeint.');
  // this.toastr.info('External Recipient Added');
  };
  
  
  
  
  
  getJobSubjectsArray(request_array) {
    this._demoService.getJobSubjectsArray(request_array).subscribe(
       data => { this.job_subjects = data;
        let res = data[0];
  
        // this.arrCase = data as object [];  // FILL THE ARRAY WITH DATA.
        // // console.log(this.arrCase);
        // this.Items = data['Items'] ;
        // this.sent_data = this.Items;
        // this.sent_data = this.myob_account_codes;
  
  
  
      },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }
  
  
   RemoveElementFromAllAutomations(key: number) {
    // removes all matching names, so it can remove multiple accidently. if they have different roles. etc
    this.allAutomations.forEach((value, index) => {
      if (value === key) {
        this.allAutomations.splice(index, 1);
      }
    });
  
        this.form.controls['subject_array'].patchValue(JSON.stringify(this.allAutomations)); // works by setting the new frorm value from parent modal.
        // rest the list
        let new_model = {
          subject_array: this.allAutomations
        }
        this.getJobSubjectsArray(new_model);
  
        this.toastr.success("Removed Subject from the event.")
  
      // :: Specifcally removes the array item without there being
      // :: @https://stackoverflow.com/questions/5767325/how-can-i-remove-a-specific-item-from-an-array
  
  };
  
  
  
  // :: Parent / Child modal test
  closeParentModelDefault(model) {
    // alert('parent component function.');
   // this.modalService.hide(1); - removed the scroll bard do not use!!!
    this.modalRef.hide();
   // this.getJobPlaintiffs(this.job_id);
   // this.refreshGrid(); // resets the grid if updated and closed.
  //  this.updateTypeClick = false; // closes the div
  // :: reset the entire page.
  // this.gfunc.globalJobSubjectViewSkipRoute(this.subject_id);
  };
  
  

 // drop down function
 onChangeVariables(args): void {



  console.log(args.itemData);
 
  alert("Testing System, " + args.value);
let data = JSON.stringify(args.itemData);
console.log("Data " + data);


let json_data = JSON.parse(data);
console.log('json_data ' + json_data.Offset)
console.log('json_data ' + json_data.Id)

  this.form.controls['service_local_timezone'].patchValue(json_data.Offset); // works by setting the new frorm value from parent modal.



  // this.form.controls['service_local_timezone'].patchValue(args.itemData); // works by setting the new frorm value from parent modal.
  // this.toastr.info("Args Value: " + args.itemData["offset"]);

  // console.log(args);


  this.model.service_local = args.value;
  this.form.controls['service_local'].patchValue(args.value); // works by setting the new frorm value from parent modal.



  //   //  let element: HTMLElement = document.createElement('p');
//   if (args.isInteracted) {
//     //  element.innerText = 'Changes happened by Interaction';
//    //  this.container.documentEditor.editor.insertText(args.value);
//    //  this.toastr.info('Variable Added at cursor position within document');
//     // hide the modal
//     // this.modalRef.hide();
// this.model.service_local = args.value;

// this.form.controls['service_local'].patchValue(args.value); // works by setting the new frorm value from parent modal.
// // prbably dont need any of this below.
    
//   } else {
//     // element.innerText = 'Changes happened by programmatic';
//   }

//   // document.getElementById('event').append(element);


};




  // // ::@https://stackblitz.com/edit/angular-bmxbmy?file=src%2Fapp%2Fapp.component.html
  // getHtml(html){
  //   return this.sanitizer.bypassSecurityTrustHtml(html);
  // }

  //   // ::@https://stackoverflow.com/questions/29369512/render-html-entities-string-in-html-with-angular properway to do it (decode html special charactors for dispaly)
  // // WORKS as I created my own function from this articel == pretty well convers
  // transform2(value: any, args?: any): any {
  //   const doc = new DOMParser().parseFromString(value, 'text/html');
  //   return doc.documentElement.textContent;
  // }








  LoadSubjectserviceOutcomeTemplateParagraph(model){
    this.show_paragraph = 0;
  
  
    console.log(JSON.stringify(model));
  let dataUtil = DataUtil.parse.parseJson(model);
  
  
    
  let model2 = model;
  /*
   "subject_attempt_type_id": "2",
    "subject_service_outcome_id": "14",
    "attempts": "Attempts are continuing."
  */
  console.log('model.attempts: ' + dataUtil.attempts)
  console.log('model.subject_attempt_type_id: ' + model2.subject_attempt_type_id )
  // model2 = model2
  // Outcome 1  Attempt, subject Did not appear, attempts, contunueing.
    if(
      // && model2.attempts == "Attempts are continuing."
      model2.subject_attempt_type_id === '2' && model2.subject_service_outcome_id === '14'
      ){
        this.load_ssot_id = 1 
        this.getSubjectServiceOutcomeTemplate(this.load_ssot_id, model);
        console.log('Outcome 1');
        this.show_paragraph = 1
  
      } // determine which template to load
      if(
        model2.subject_attempt_type_id === '2' && model2.subject_service_outcome_id === '14' && model2.attempts == "Our agent will now close their file."
        ){
          // this.load_ssot_id = 2 
          // this.getSubjectServiceOutcomeTemplate(this.load_ssot_id, model);
          // console.log('Outcome 2');
          // this.show_paragraph = 1
        } // determine which template to load
  
  // TRIGGERS AND SWITCHES - Real & Live
  
  
  
  // BOF Subject Service.
  // Service :: 1 - Personal
  if(
    model2.subject_attempt_type_id === '1' && model2.subject_service_outcome_id === '1' && model2.subject_service_method_id === '1' && model2.who_service >= 1
    ){
      this.load_ssot_id = 1 
        this.getSubjectServiceOutcomeTemplate(this.load_ssot_id, model);
        // this.toastr.info("Service :: 1 - Personal");
        console.log('Service :: 1 - Personal');
        this.show_paragraph = 1
    }
    // Service :: 2 - Personal Service: In thier capacity as Director
  if(
    model2.subject_attempt_type_id === '1' && model2.subject_service_outcome_id === '1' && model2.subject_service_method_id === '6' && model2.who_service >= 1
    ){
      this.load_ssot_id = 5 // This must be unique for each paragraph output... hard coded to match data records. 
        this.getSubjectServiceOutcomeTemplate(this.load_ssot_id, model);
        // this.toastr.info("Service :: 2 - Personal Service: In thier capacity as Director");
        this.show_paragraph = 1
    }
  
      // Service :: 3 - Personal Service: Personal Service to Witness
  if(
    model2.subject_attempt_type_id === '1' && model2.subject_service_outcome_id === '1' && model2.subject_service_method_id === '7' && model2.who_service >= 1 && model2.witness_name != null
    ){
      this.load_ssot_id = 6 // This must be unique for each paragraph output... hard coded to match data records. 
        this.getSubjectServiceOutcomeTemplate(this.load_ssot_id, model);
        // this.toastr.info("Service :: 3 - Personal Service: Personal Service to Witness");
        this.show_paragraph = 1
    }
        // Service :: 4 - Personal Service: Non-Personal to fellow occupant
  if(
    model2.subject_attempt_type_id === '1' && model2.subject_service_outcome_id === '1' && model2.subject_service_method_id === '2' && model2.who_service >= 1 && model2.fellow_occupants_name != null
    ){
      this.load_ssot_id = 7 // This must be unique for each paragraph output... hard coded to match data records. 
        this.getSubjectServiceOutcomeTemplate(this.load_ssot_id, model);
        // this.toastr.info("Service :: 4 - Personal Service: Non-Personal to fellow occupant");
        this.show_paragraph = 1
    }
  // Service :: 5 - Personal Service: Non-Personal to an authorised employee
      if(
        model2.subject_attempt_type_id === '1' && model2.subject_service_outcome_id === '1' && model2.subject_service_method_id === '3' && model2.who_service >= 1 && model2.authorised_employee_name != null
        ){
          this.load_ssot_id = 8 // This must be unique for each paragraph output... hard coded to match data records. 
            this.getSubjectServiceOutcomeTemplate(this.load_ssot_id, model);
            // this.toastr.info("Service :: 5 - Personal Service: Non-Personal to an authorised employee");
            this.show_paragraph = 1
        }
  
  // Service :: 6 - Personal Service: Non-Personal by affixing to the front door
  if(
    model2.subject_attempt_type_id === '1' && model2.subject_service_outcome_id === '1' && model2.subject_service_method_id === '8' && model2.who_service >= 1
    ){
      this.load_ssot_id = 9 // This must be unique for each paragraph output... hard coded to match data records. 
        this.getSubjectServiceOutcomeTemplate(this.load_ssot_id, model);
        // this.toastr.info("Service :: 6 - Personal Service: Non-Personal by affixing to the front door");
        this.show_paragraph = 1
    }    
    
    
  // Service ::id22 - Individual Service (Residential): Placing under the Front Door 
  if(
    model2.subject_attempt_type_id === '1' && model2.subject_service_outcome_id === '1' && model2.subject_service_method_id === '22' && model2.who_service >= 1
    ){
      this.load_ssot_id = 47 // This must be unique for each paragraph output... hard coded to match data records. 
        this.getSubjectServiceOutcomeTemplate(this.load_ssot_id, model);
        // this.toastr.info("Service :: 6 - Personal Service: Non-Personal by affixing to the front door");
        this.show_paragraph = 1
    }
    
   // ::id23  Individual Service (Residential): Affixing to the Front Gate or Fence
if(
  model2.subject_attempt_type_id === '1' && model2.subject_service_outcome_id === '1' && model2.subject_service_method_id === '23' && model2.who_service >= 1
  ){
    this.load_ssot_id = 48 // This must be unique for each paragraph output... hard coded to match data records. 
      this.getSubjectServiceOutcomeTemplate(this.load_ssot_id, model);
      // this.toastr.info("Service :: 6 - Personal Service: Non-Personal by affixing to the front door");
      this.show_paragraph = 1
  }  
  
   // ::id24 Individual Service (Residential): Affixing at Vacant Land
if(
  model2.subject_attempt_type_id === '1' && model2.subject_service_outcome_id === '1' && model2.subject_service_method_id === '24' && model2.who_service >= 1
  ){
    this.load_ssot_id = 49 // This must be unique for each paragraph output... hard coded to match data records. 
      this.getSubjectServiceOutcomeTemplate(this.load_ssot_id, model);
      // this.toastr.info("Service :: 6 - Personal Service: Non-Personal by affixing to the front door");
      this.show_paragraph = 1
  }   
    
// ::id25 Individual Service: Leaving in their Presence
if(
model2.subject_attempt_type_id === '1' && model2.subject_service_outcome_id === '1' && model2.subject_service_method_id === '25' && model2.who_service >= 1
){
  this.load_ssot_id = 50 // This must be unique for each paragraph output... hard coded to match data records. 
    this.getSubjectServiceOutcomeTemplate(this.load_ssot_id, model);
    // this.toastr.info("Service :: 6 - Personal Service: Non-Personal by affixing to the front door");
    this.show_paragraph = 1
}  

// ::id26 Individual Service: Keeping House NSW only (UCPR Rule 10.26)
if(
  model2.subject_attempt_type_id === '1' && model2.subject_service_outcome_id === '1' && model2.subject_service_method_id === '26' && model2.who_service >= 1
  ){
    this.load_ssot_id = 51 // This must be unique for each paragraph output... hard coded to match data records. 
      this.getSubjectServiceOutcomeTemplate(this.load_ssot_id, model);
      // this.toastr.info("Service :: 6 - Personal Service: Non-Personal by affixing to the front door");
      this.show_paragraph = 1
  }  


  // ::id27 Individual (Hand Delivery of Letter or NTV): Personal
  if(
    model2.subject_attempt_type_id === '1' && model2.subject_service_outcome_id === '1' && model2.subject_service_method_id === '27' && model2.who_service >= 1
    ){
      this.load_ssot_id = 52 // This must be unique for each paragraph output... hard coded to match data records. 
        this.getSubjectServiceOutcomeTemplate(this.load_ssot_id, model);
        // this.toastr.info("Service :: 6 - Personal Service: Non-Personal by affixing to the front door");
        this.show_paragraph = 1
    }  
  
  // ::id28 Individual or Company: Delivery of Letter or NTV: Affixing to the Front Door
  if(
    model2.subject_attempt_type_id === '1' && model2.subject_service_outcome_id === '1' && model2.subject_service_method_id === '28' && model2.who_service >= 1
    ){
      this.load_ssot_id = 53 // This must be unique for each paragraph output... hard coded to match data records. 
        this.getSubjectServiceOutcomeTemplate(this.load_ssot_id, model);
        // this.toastr.info("Service :: 6 - Personal Service: Non-Personal by affixing to the front door");
        this.show_paragraph = 1
    }  
  
  // ::id29 Individual or Company: Delivery of Letter or NTV: Leaving in the Letterbox
  if(
    model2.subject_attempt_type_id === '1' && model2.subject_service_outcome_id === '1' && model2.subject_service_method_id === '29' && model2.who_service >= 1
    ){
      this.load_ssot_id = 54 // This must be unique for each paragraph output... hard coded to match data records. 
        this.getSubjectServiceOutcomeTemplate(this.load_ssot_id, model);
        // this.toastr.info("Service :: 6 - Personal Service: Non-Personal by affixing to the front door");
        this.show_paragraph = 1
    }  
    // ::id30 Individual or Company: Delivery of Letter or NTV: Placing under the Front Door
    if(
      model2.subject_attempt_type_id === '1' && model2.subject_service_outcome_id === '1' && model2.subject_service_method_id === '30' && model2.who_service >= 1
      ){
        this.load_ssot_id = 55 // This must be unique for each paragraph output... hard coded to match data records. 
          this.getSubjectServiceOutcomeTemplate(this.load_ssot_id, model);
          // this.toastr.info("Service :: 6 - Personal Service: Non-Personal by affixing to the front door");
          this.show_paragraph = 1
      }  
    
  // ::id31 Individual or Company: Delivery of Letter or NTV: Placing under the Front Door
  if(
    model2.subject_attempt_type_id === '1' && model2.subject_service_outcome_id === '1' && model2.subject_service_method_id === '31' && model2.who_service >= 1
    ){
      this.load_ssot_id = 56 // This must be unique for each paragraph output... hard coded to match data records. 
        this.getSubjectServiceOutcomeTemplate(this.load_ssot_id, model);
        // this.toastr.info("Service :: 6 - Personal Service: Non-Personal by affixing to the front door");
        this.show_paragraph = 1
    }  
  
  // ::id32 Trust: Personal Service on Trustee
  if(
    model2.subject_attempt_type_id === '1' && model2.subject_service_outcome_id === '1' && model2.subject_service_method_id === '32' && model2.who_service >= 1
    ){
      this.load_ssot_id = 57 // This must be unique for each paragraph output... hard coded to match data records. 
        this.getSubjectServiceOutcomeTemplate(this.load_ssot_id, model);
        // this.toastr.info("Service :: 6 - Personal Service: Non-Personal by affixing to the front door");
        this.show_paragraph = 1
    }  
    


  // WAS missing.
// Service :: 6+++ - Personal Service: Non-Personal by leaving in the letterbox
if(
  model2.subject_attempt_type_id === '1' && model2.subject_service_outcome_id === '1' && model2.subject_service_method_id === '9' && model2.who_service >= 1
  ){
    this.load_ssot_id = 42 // This must be unique for each paragraph output... hard coded to match data records. 
      this.getSubjectServiceOutcomeTemplate(this.load_ssot_id, model);
      // this.toastr.info("Service :: 6 - Personal Service: Non-Personal by affixing to the front door");
      this.show_paragraph = 1
  }      
     

        
  // Service :: 7 - Business of Partnership - Non Personal - Person in Charge
  if(
    model2.subject_attempt_type_id === '1' && model2.subject_service_outcome_id === '1' && model2.subject_service_method_id === '20' && model2.who_service >= 1
    ){
      this.load_ssot_id = 10 // This must be unique for each paragraph output... hard coded to match data records. 
        this.getSubjectServiceOutcomeTemplate(this.load_ssot_id, model);
        // this.toastr.info("Service :: 7 - Business of Partnership - Non Personal - Person in Charge");
        this.show_paragraph = 1
    }    
  // Service :: 8 - Non Personal - By Post
  if(
    model2.subject_attempt_type_id === '1' && model2.subject_service_outcome_id === '1' && model2.subject_service_method_id === '13' && model2.who_service >= 1
    ){
      this.load_ssot_id = 11 // This must be unique for each paragraph output... hard coded to match data records. 
        this.getSubjectServiceOutcomeTemplate(this.load_ssot_id, model);
        // this.toastr.info("Service :: 8 - Non Personal - By Post");
        this.show_paragraph = 1
    }
  // Service :: 9 - Non Personal - By Email
  if(
    model2.subject_attempt_type_id === '1' && model2.subject_service_outcome_id === '1' && model2.subject_service_method_id === '14' && model2.who_service >= 1
    ){
      this.load_ssot_id = 12 // This must be unique for each paragraph output... hard coded to match data records. 
        this.getSubjectServiceOutcomeTemplate(this.load_ssot_id, model);
        // this.toastr.info("Service :: 9 - Non Personal - By Email");
        this.show_paragraph = 1
    }          
  // Service :: 10 - Non Personal - to Authorised Legal Representative QLD
  if(
    model2.subject_attempt_type_id === '1' && model2.subject_service_outcome_id === '1' && model2.subject_service_method_id === '10' && model2.who_service >= 1
    ){
      this.load_ssot_id = 13 // This must be unique for each paragraph output... hard coded to match data records. 
        this.getSubjectServiceOutcomeTemplate(this.load_ssot_id, model);
        // this.toastr.info("Service :: 10 - Non Personal - to Authorised Legal Representative QLD");
        this.show_paragraph = 1
    }          
  // Service :: 11 - Non Personal - to Authorised Legal Representative Non-QLD
  if(
    model2.subject_attempt_type_id === '1' && model2.subject_service_outcome_id === '1' && model2.subject_service_method_id === '11' && model2.who_service >= 1
    ){
      this.load_ssot_id = 14 // This must be unique for each paragraph output... hard coded to match data records. 
        this.getSubjectServiceOutcomeTemplate(this.load_ssot_id, model);
        // this.toastr.info("Service :: 11 - Non Personal - to Authorised Legal Representative Non-QLD");
        this.show_paragraph = 1
    }  
  // Service :: 12 - Non Personal - Service on Prisoner to Person in charge of Prison
  if(
    model2.subject_attempt_type_id === '1' && model2.subject_service_outcome_id === '1' && model2.subject_service_method_id === '12' && model2.who_service >= 1
    ){
      this.load_ssot_id = 15 // This must be unique for each paragraph output... hard coded to match data records. 
        this.getSubjectServiceOutcomeTemplate(this.load_ssot_id, model);
        // this.toastr.info("Service :: 12 - Non Personal - Service on Prisoner to Person in charge of Prison");
        this.show_paragraph = 1
    }  
  // Service :: 13 - By affixing to a building or leaving in a letterbox
  if(
    model2.subject_attempt_type_id === '1' && model2.subject_service_outcome_id === '1' && model2.subject_service_method_id === '5' && model2.who_service >= 1
    ){
      this.load_ssot_id = 16 // This must be unique for each paragraph output... hard coded to match data records. 
        this.getSubjectServiceOutcomeTemplate(this.load_ssot_id, model);
        // this.toastr.info("Service :: 13 - By affixing to a building or leaving in a letterbox");
        this.show_paragraph = 1
    }  
  // Service :: 14 - To the Registered Office
  if(
    model2.subject_attempt_type_id === '1' && model2.subject_service_outcome_id === '1' && model2.subject_service_method_id === '4' && model2.who_service >= 1
    ){
      this.load_ssot_id = 17 // This must be unique for each paragraph output... hard coded to match data records. 
        this.getSubjectServiceOutcomeTemplate(this.load_ssot_id, model);
        // this.toastr.info("Service :: 14 - To the Registered Office");
        this.show_paragraph = 1
    }  
  
  // Skipped a few as they do not exist in the system.
  
  // Service :: 18 - Company - Registered Office - Authorised Employee
  if(
    model2.subject_attempt_type_id === '1' && model2.subject_service_outcome_id === '1' && model2.subject_service_method_id === '15' && model2.who_service >= 1
    ){
      this.load_ssot_id = 18 // This must be unique for each paragraph output... hard coded to match data records. 
        this.getSubjectServiceOutcomeTemplate(this.load_ssot_id, model);
        // this.toastr.info("Service :: 18 - Company - Registered Office - Authorised Employee");
        this.show_paragraph = 1
    }  
  
  // Service :: 19 - Company - Registered Office - By Affixing to the address
  if(
    model2.subject_attempt_type_id === '1' && model2.subject_service_outcome_id === '1' && model2.subject_service_method_id === '16' && model2.who_service >= 1
    ){
      this.load_ssot_id = 19 // This must be unique for each paragraph output... hard coded to match data records. 
        this.getSubjectServiceOutcomeTemplate(this.load_ssot_id, model);
        // this.toastr.info("Service :: 19 - Company - Registered Office - By Affixing to the address");
        this.show_paragraph = 1
    }  
  
  
  // Service :: 21 - Company - Registered Office - By sliding under the door
  if(
    model2.subject_attempt_type_id === '1' && model2.subject_service_outcome_id === '1' && model2.subject_service_method_id === '17' && model2.who_service >= 1
    ){
      this.load_ssot_id = 20 // This must be unique for each paragraph output... hard coded to match data records. 
        this.getSubjectServiceOutcomeTemplate(this.load_ssot_id, model);
        // this.toastr.info("Service :: 21 - Company - Registered Office - By sliding under the door");
        this.show_paragraph = 1
    }  
  
  // Service :: 22 - Company - Registered Office - By leaving in the letterbox
  if(
    model2.subject_attempt_type_id === '1' && model2.subject_service_outcome_id === '1' && model2.subject_service_method_id === '18' && model2.who_service >= 1
    ){
      this.load_ssot_id = 21 // This must be unique for each paragraph output... hard coded to match data records. 
        this.getSubjectServiceOutcomeTemplate(this.load_ssot_id, model);
        // this.toastr.info("Service :: 22 - Company - Registered Office - By leaving in the letterbox");
        this.show_paragraph = 1
    }  
  
  
  // Service :: 23 - Company - Registered Office - Personal Service on Director
  if(
    model2.subject_attempt_type_id === '1' && model2.subject_service_outcome_id === '1' && model2.subject_service_method_id === '19' && model2.who_service >= 1
    ){
      this.load_ssot_id = 22 // This must be unique for each paragraph output... hard coded to match data records. 
        this.getSubjectServiceOutcomeTemplate(this.load_ssot_id, model);
        // this.toastr.info("Service :: 23 - Company - Registered Office - Personal Service on Director");
        this.show_paragraph = 1
    }  
  
  // Service :: 24 - Service Under Order
  if(
    model2.subject_attempt_type_id === '1' && model2.subject_service_outcome_id === '1' && model2.subject_service_method_id === '21' && model2.who_service >= 1
    ){
      this.load_ssot_id = 23 // This must be unique for each paragraph output... hard coded to match data records. 
        this.getSubjectServiceOutcomeTemplate(this.load_ssot_id, model);
        // this.toastr.info("Service :: 24 - Service Under Order");
        this.show_paragraph = 1
    }  
  
  
  
  
  // BOF: SUBJECT Attendance
  
  // Attendance :: 25 - Documents Not Served - Person spoken With at the address
  if(
    model2.subject_attempt_type_id === '2' && model2.subject_service_outcome_id === '8' && model2.subject_location_status_id === '2' && model2.who_service >= 1
    ){
      this.load_ssot_id = 24 // This must be unique for each paragraph output... hard coded to match data records. 
        this.getSubjectServiceOutcomeTemplate(this.load_ssot_id, model);
        // this.toastr.info("Attendance :: 25 - Documents Not Served - Person spoken With at the address");
        this.show_paragraph = 1
    }  
  
  
  // Attendance :: 26 - Documents Not Served - no one home at the address
  if(
    model2.subject_attempt_type_id === '2' && model2.subject_service_outcome_id === '8' && model2.subject_location_status_id === '1' && model2.who_service >= 1
    ){
      this.load_ssot_id = 25 // This must be unique for each paragraph output... hard coded to match data records. 
        this.getSubjectServiceOutcomeTemplate(this.load_ssot_id, model);
        // this.toastr.info("Attendance :: 26 - Documents Not Served - no one home at the address");
        this.show_paragraph = 1
    }  
  
  // Attendance :: 27 - Subject not Located at address - Person spoken With at the address
  if(
    model2.subject_attempt_type_id === '2' && model2.subject_service_outcome_id === '10' && model2.subject_location_status_id === '2' && model2.who_service >= 1
    ){
      this.load_ssot_id = 26 // This must be unique for each paragraph output... hard coded to match data records. 
        this.getSubjectServiceOutcomeTemplate(this.load_ssot_id, model);
        // this.toastr.info("Attendance :: 27 - Subject not Located at address - Person spoken With at the address");
        this.show_paragraph = 1
    }  
  
    // Attendance :: 28 - Subject not Located at address - no one home at the address
  if(
    model2.subject_attempt_type_id === '2' && model2.subject_service_outcome_id === '10' && model2.subject_location_status_id === '1' && model2.who_service >= 1
    ){
      this.load_ssot_id = 27 // This must be unique for each paragraph output... hard coded to match data records. 
        this.getSubjectServiceOutcomeTemplate(this.load_ssot_id, model);
        // this.toastr.info("Attendance :: 28 - Subject not Located at address - no one home at the address");
        this.show_paragraph = 1
    }  
  
  // Attendance :: 29 - Field Call - Person spoken With at the address
  if(
    model2.subject_attempt_type_id === '2' && model2.subject_service_outcome_id === '24' && model2.subject_location_status_id === '2' && model2.who_service >= 1
    ){
      this.load_ssot_id = 28 // This must be unique for each paragraph output... hard coded to match data records. 
        this.getSubjectServiceOutcomeTemplate(this.load_ssot_id, model);
        // this.toastr.info("Attendance :: 29 - Field Call - Person spoken With at the address");
        this.show_paragraph = 1
    }  
  
  
  // Attendance :: 30 - Field Call - no one home at the address
  if(
    model2.subject_attempt_type_id === '2' && model2.subject_service_outcome_id === '24' && model2.subject_location_status_id === '1' && model2.who_service >= 1
    ){
      this.load_ssot_id = 29 // This must be unique for each paragraph output... hard coded to match data records. 
        this.getSubjectServiceOutcomeTemplate(this.load_ssot_id, model);
        // this.toastr.info("Attendance :: 30 - Field Call - no one home at the address");
        this.show_paragraph = 1
    }  
  
  
      // // Attendance :: 33 - Field Call Attendance -- NEW GENERAL ATTENDANCE STAFF Nov 2033
if(
  model2.subject_attempt_type_id === '2' && model2.subject_service_outcome_id === '25'  && model2.who_service >= 1 
  ){
    this.load_ssot_id = 30 // This must be unique for each paragraph output... hard coded to match data records. 
      this.getSubjectServiceOutcomeTemplate(this.load_ssot_id, model);
      // this.toastr.info("Attendance :: 33 - Field Call Attendance");
      this.show_paragraph = 1
  }  
  
  // Attendance :: 33 - Field Call Attendance
  // if(
  //   model2.subject_attempt_type_id === '2' && model2.subject_service_outcome_id === '24'  && model2.who_service >= 1
  //   ){
  //     this.load_ssot_id = 30 // This must be unique for each paragraph output... hard coded to match data records. 
  //       this.getSubjectServiceOutcomeTemplate(this.load_ssot_id, model);
  //       // this.toastr.info("Attendance :: 33 - Field Call Attendance");
  //       this.show_paragraph = 1
  //   }  
  
  // Attendance :: 34 - Occupancy Check Attendance
  if(
    model2.subject_attempt_type_id === '2' && model2.subject_service_outcome_id === '11'  && model2.who_service >= 1
    ){
      this.load_ssot_id = 31 // This must be unique for each paragraph output... hard coded to match data records. 
        this.getSubjectServiceOutcomeTemplate(this.load_ssot_id, model);
        // this.toastr.info("Attendance :: 34 - Occupancy Check Attendance");
        this.show_paragraph = 1
    }  
  
  
  // Attendance :: 35 - Drive-by Inspection Report
  if(
    model2.subject_attempt_type_id === '2' && model2.subject_service_outcome_id === '12'  && model2.who_service >= 1
    ){
      this.load_ssot_id = 32 // This must be unique for each paragraph output... hard coded to match data records. 
        this.getSubjectServiceOutcomeTemplate(this.load_ssot_id, model);
        // this.toastr.info("Attendance :: 35 - Drive-by Inspection Report");
        this.show_paragraph = 1
    }  
  
  
  // Attendance :: 36 - Appeared
  if(
    model2.subject_attempt_type_id === '2' && model2.subject_service_outcome_id === '13'  && model2.who_service >= 1
    ){
      this.load_ssot_id = 33 // This must be unique for each paragraph output... hard coded to match data records. 
        this.getSubjectServiceOutcomeTemplate(this.load_ssot_id, model);
        // this.toastr.info("Attendance :: 36 - Appeared");
        this.show_paragraph = 1
    }  
  
  // Attendance :: 37 - Did Not Appear
  if(
    model2.subject_attempt_type_id === '2' && model2.subject_service_outcome_id === '14'  && model2.who_service >= 1
    ){
      this.load_ssot_id = 34 // This must be unique for each paragraph output... hard coded to match data records. 
        this.getSubjectServiceOutcomeTemplate(this.load_ssot_id, model);
        // this.toastr.info("Attendance :: 37 - Did Not Appear");
        this.show_paragraph = 1
    }  
  
  // Attendance :: 38 - Document Filing
  if(
    model2.subject_attempt_type_id === '2' && model2.subject_service_outcome_id === '15'  && model2.who_service >= 1
    ){
      this.load_ssot_id = 35 // This must be unique for each paragraph output... hard coded to match data records. 
        this.getSubjectServiceOutcomeTemplate(this.load_ssot_id, model);
        // this.toastr.info("Attendance :: 38 - Document Filing");
        this.show_paragraph = 1
    }  
  
  // Attendance :: 39 - Lockout Report
  if(
    model2.subject_attempt_type_id === '2' && model2.subject_service_outcome_id === '16'  && model2.who_service >= 1
    ){
      this.load_ssot_id = 36 // This must be unique for each paragraph output... hard coded to match data records. 
        this.getSubjectServiceOutcomeTemplate(this.load_ssot_id, model);
        // this.toastr.info("Attendance :: 39 - Lockout Report");
        this.show_paragraph = 1
    }  
  
    // Attendance :: 40 - Phone Call Made
  if(
    model2.subject_attempt_type_id === '2' && model2.subject_service_outcome_id === '17'  && model2.who_service >= 1
    ){
      this.load_ssot_id = 37 // This must be unique for each paragraph output... hard coded to match data records. 
        this.getSubjectServiceOutcomeTemplate(this.load_ssot_id, model);
        // this.toastr.info("Attendance :: 40 - Phone Call Made");
        this.show_paragraph = 1
    }  
  
  // id28: Text Message Sent
    if(
      model2.subject_attempt_type_id === '2' && model2.subject_service_outcome_id === '28'  && model2.who_service >= 1
      ){
        this.load_ssot_id = 61 // This must be unique for each paragraph output... hard coded to match data records. 
          this.getSubjectServiceOutcomeTemplate(this.load_ssot_id, model);
          // this.toastr.info("Attendance :: 40 - Phone Call Made");
          this.show_paragraph = 1
      }  


        // id29: Text Message Sent
    if(
      model2.subject_attempt_type_id === '2' && model2.subject_service_outcome_id === '29'  && model2.who_service >= 1
      ){
        this.load_ssot_id = 62 // This must be unique for each paragraph output... hard coded to match data records. 
          this.getSubjectServiceOutcomeTemplate(this.load_ssot_id, model);
          // this.toastr.info("Attendance :: 40 - Phone Call Made");
          this.show_paragraph = 1
      }  
    
    


    // Attendance :: 41 - Phone Call Received
    if(
      model2.subject_attempt_type_id === '2' && model2.subject_service_outcome_id === '18'  && model2.who_service >= 1
      ){
        this.load_ssot_id = 38 // This must be unique for each paragraph output... hard coded to match data records. 
          this.getSubjectServiceOutcomeTemplate(this.load_ssot_id, model);
          // this.toastr.info("Attendance :: 41 - Phone Call Received");
          this.show_paragraph = 1
      }  
    
    
    // Attendance :: 42 - Email Sent
    if(
      model2.subject_attempt_type_id === '2' && model2.subject_service_outcome_id === '19'  && model2.who_service >= 1
      ){
        this.load_ssot_id = 39 // This must be unique for each paragraph output... hard coded to match data records. 
          this.getSubjectServiceOutcomeTemplate(this.load_ssot_id, model);
          // this.toastr.info("Attendance :: 42 - Email Sent");
          this.show_paragraph = 1
      }  
    
      
    // Attendance :: 43 - Email Received
    if(
      model2.subject_attempt_type_id === '2' && model2.subject_service_outcome_id === '20'  && model2.who_service >= 1
      ){
        this.load_ssot_id = 40 // This must be unique for each paragraph output... hard coded to match data records. 
          this.getSubjectServiceOutcomeTemplate(this.load_ssot_id, model);
          // this.toastr.info("Attendance :: 43 - Email Received");
          this.show_paragraph = 1
      }  
    
      // Attendance :: 44 - The Subject was interviewed at the address
      if(
        model2.subject_attempt_type_id === '2' && model2.subject_service_outcome_id === '9'  && model2.who_service >= 1
        ){
          this.load_ssot_id = 41 // This must be unique for each paragraph output... hard coded to match data records. 
            this.getSubjectServiceOutcomeTemplate(this.load_ssot_id, model);
            // this.toastr.info("Attendance :: 44 - The Subject was interviewed at the address");
            this.show_paragraph = 1
            
        }  
      
      
        
        
    
     // Missing skip Traces in the code?
      
  
  
    // Attendance :: 45 - Skip Trace - Located
    if(
      model2.subject_attempt_type_id === '2' && model2.subject_service_outcome_id === '21'  && model2.who_service >= 1
      ){
        this.load_ssot_id = 43 // This must be unique for each paragraph output... hard coded to match data records. 
          this.getSubjectServiceOutcomeTemplate(this.load_ssot_id, model);
          // this.toastr.info("Attendance :: 44 - The Subject was interviewed at the address");
          this.show_paragraph = 1
          
      }  


    // Attendance :: 46 - Skip Trace - Possible Locate
    if(
      model2.subject_attempt_type_id === '2' && model2.subject_service_outcome_id === '22'  && model2.who_service >= 1
      ){
        this.load_ssot_id = 44 // This must be unique for each paragraph output... hard coded to match data records. 
          this.getSubjectServiceOutcomeTemplate(this.load_ssot_id, model);
          // this.toastr.info("Attendance :: 44 - The Subject was interviewed at the address");
          this.show_paragraph = 1
          
      }  


    // Attendance :: 47 - Skip Trace - Not Located
    if(
      model2.subject_attempt_type_id === '2' && model2.subject_service_outcome_id === '23'  && model2.who_service >= 1
      ){
        this.load_ssot_id = 45 // This must be unique for each paragraph output... hard coded to match data records. 
          this.getSubjectServiceOutcomeTemplate(this.load_ssot_id, model);
          // this.toastr.info("Attendance :: 44 - The Subject was interviewed at the address");
          this.show_paragraph = 1
          
      }  

        // id36 the address could not be located
        if(
          model2.subject_attempt_type_id === '2' && model2.subject_service_outcome_id === '26'  && model2.who_service >= 1
          ){
            this.load_ssot_id = 58 // This must be unique for each paragraph output... hard coded to match data records. 
              this.getSubjectServiceOutcomeTemplate(this.load_ssot_id, model);
              // this.toastr.info("Attendance :: 44 - The Subject was interviewed at the address");
              this.show_paragraph = 1
              
          }  
  
  
  
    // id27 Occupancy Check: (Complete the Text Box Field Below)
    if(
      model2.subject_attempt_type_id === '2' && model2.subject_service_outcome_id === '27' && model2.subject_location_status_id === '2' && model2.who_service >= 1
      ){
        this.load_ssot_id = 59 // This must be unique for each paragraph output... hard coded to match data records. 
          this.getSubjectServiceOutcomeTemplate(this.load_ssot_id, model);
          // this.toastr.info("Attendance :: 29 - Field Call - Person spoken With at the address");
          this.show_paragraph = 1
      }  
    
    
    //  Occupancy Check: (Complete the Text Box Field Below)
    // Attendance :: 30 - Field Call - no one home at the address
    if(
      model2.subject_attempt_type_id === '2' && model2.subject_service_outcome_id === '27' && model2.subject_location_status_id === '1' && model2.who_service >= 1
      ){
        this.load_ssot_id = 60 // This must be unique for each paragraph output... hard coded to match data records. 
          this.getSubjectServiceOutcomeTemplate(this.load_ssot_id, model);
          // this.toastr.info("Attendance :: 30 - Field Call - no one home at the address");
          this.show_paragraph = 1
      }  
    
  
      //  id28 text sent
      if(
        model2.subject_attempt_type_id === '2' && model2.subject_service_outcome_id === '28'  && model2.who_service >= 1
        ){
          this.load_ssot_id = 61 // This must be unique for each paragraph output... hard coded to match data records. 
            this.getSubjectServiceOutcomeTemplate(this.load_ssot_id, model);
            // this.toastr.info("Attendance :: 44 - The Subject was interviewed at the address");
            this.show_paragraph = 1
            
        }  
  

    //  id29 text recieved
    if(
      model2.subject_attempt_type_id === '2' && model2.subject_service_outcome_id === '29'  && model2.who_service >= 1
      ){
        this.load_ssot_id = 62 // This must be unique for each paragraph output... hard coded to match data records. 
          this.getSubjectServiceOutcomeTemplate(this.load_ssot_id, model);
          // this.toastr.info("Attendance :: 44 - The Subject was interviewed at the address");
          this.show_paragraph = 1
          
      }  
  
        // Subject service Affixed to -- any attempts (outcomes)
        // && model2.attempts == "".
  
  // Older methods written into the system above.
        // if(
            //   model2.subject_attempt_type_id === '1' && model2.subject_service_outcome_id === '1' && model2.subject_service_method_id === '5'
            //   ){
            //     this.load_ssot_id = 4 
            //     this.getSubjectServiceOutcomeTemplate(this.load_ssot_id, model);
            //     console.log('Outcome 2');
            //     this.show_paragraph = 1
            //   } // determine which template to load
  
  
      // this.getSubjectServiceOutcomeTemplate(1, model);
      
    let load_ssot_id = 1
  
  }
  
  
  // PHP script ot render paragraph
  private getSubjectServiceOutcomeTemplateRendered(ssot_id, model) {
  
  
  }


  getSubjectServiceOutcomeTemplate_ResolutionOutcomes(ssot_id) {



    this._demoService.getSubjectServiceOutcomeTemplate(ssot_id).subscribe(
       data => { this.subject_service_outome_template_resolution_outcomes = data;
        let res = data[0];
  
        this.subject_service_resolution_outcome_required = res.subject_service_resolution_outcome_required;

        // preload the resolutions
        let new_model = {
                  subject_service_resolution_outcome_array: JSON.parse(res.subject_service_resolution_outcome_array)
                }
      // this.form.controls['subject_service_resolution_outcome_array'].patchValue(JSON.stringify(data.subject_service_resolution_outcome_array)); // works by setting the new frorm value from parent modal.
      this.getSystemResolutionsArray(new_model)
      this.allResolutions = JSON.parse(res.subject_service_resolution_outcome_array);
      if(res.subject_service_resolution_outcome_array == null){this.allResolutions = []} // Sets incase of nulls
      this.syncResolutionOutcomeAnswersFromModel(this.model);
  


  
  
      },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }


  
  private getSubjectServiceOutcomeTemplate(ssot_id, model) {


    // Variable Name Functions FIST
   // Run Some Functinos to get the real Values not IDS. MUST RUN THESE FIRST TO LOAD CONTENT NBELOW
  
  
   // LOOKUPS FIRST....
  
   // Must have if statements otherwise breaks the merge variables conversions
   if(model.subject_attempt_type_id != ''){
   this.getSubjectAttemptType_Q(model.subject_attempt_type_id);
   }
   if(model.subject_attempt_type_id != ''){
    this.getBrand_Q(model.who_service);
   }
   // Job report client
  if(this.job_model.brand_report_id != '' && this.job_model){
    this.getBrand_report_Q(this.job_model.brand_report_id); // this line was wrong.. needed brand id.
    // this.getBrand_report_Q(this.job_model.brand_id);
   }
   // can only activate particular functions if the content exiss otherwise crashes the entire system
    if(model.subject_service_type_id){
   this.getSubjectServiceType_Q(model.subject_service_type_id);
    }
    
    
  // october 2023 was missing
  if(model.property_type_id){
    this.getPropertyType(model.property_type_id);
  }
  
    if(model.subject_service_method_id){
   this.getServiceMethod_Q(model.subject_service_method_id) ;
    }
  
  
    if(this.subject_model.job_subject_type_id){
      this.getJobSubjectType_Q(this.subject_model.job_subject_type_id) ;
       }
     
  
    if(model.fellow_occupants_relationship){
  //$templateProcessor->setValue($f_starter . 'subject_relationship_name' ,  $json_serviceR[0]->subject_relationship_name);
  this.getSubjectRelationship_Q(model.fellow_occupants_relationship)
  // /fellow_occupants_relationship
  
    }else{
      // this.subject_service_fellow_relationship.subject_relationship_name == null;
    }
  
  
  if(model.subject_service_outcome_id){
  this.getSubjectServiceOutcome_Q(model.subject_service_outcome_id) ;
    }
  
  
  if(model.exact_service_method_id ){
  this.getSubjectExactServiceMethod_Q(model.exact_service_method_id) ;
  }
  
  // // subject service october for method to show name if note an ID.
  if( model.exact_service_method){
    // may need to lookup differently
    this.getSubjectExactServiceMethod_Q(model.exact_service_method) ;
    }
  
  if(model.subject_location_status_id){
  this.getSubjectLocationStatus_Q(model.subject_location_status_id) ;
    }   
  
    if(model.subject_location_status_found_id){
      this.getSubjectLocationStatusFound_Q(model.subject_location_status_found_id) ;
        }   
    
  
  
  // clear everything
  model.service_paragraph = '';
  // this.attemptForm.controls['service_paragraph'].patchValue('');
  model.service_paragraph_rendered = '';
  // this.attemptForm.controls['service_paragraph_rendered'].patchValue('');
  
    this._demoService.getSubjectServiceOutcomeTemplate(ssot_id)
      .subscribe(
        res => {
          this.subject_service_outome_template = res;
          let data = res[0]
  
  
     // Just hide all this section as not required.     
        model.service_paragraph = data.ssot_template_HTML;
        this.attemptForm.controls['service_paragraph'].patchValue(data.ssot_template_HTML);
  
        // October  2023 :: Add template ssot_id to attempt so triggers and automations can run conditions.
        model.ssot_id = data.ssot_id;
        this.attemptForm.controls['ssot_id'].patchValue(data.ssot_id);
  



        
            // // Meger Variables one by one - this works but only one at a time
            //   var str = data.ssot_template_HTML;
            //   var newstr = str.replace('${f_subject_name}', "oranges",); 
            //   // newstr = str.replace('${job_instructions_month}', "January"); 
              
            //   this.model.service_paragraph_rendered = newstr;
            //   this.attemptForm.controls['service_paragraph_rendered'].patchValue(newstr);
  
  
                  // // merge variables using a mapped object
                  // // @:https://stackoverflow.com/questions/15604140/replace-multiple-strings-with-multiple-other-strings
  
                  // var str = data.ssot_template_HTML;
                  // var mapObj = {
                  // "${f_subject_name}":"dog",
                  // "${job_instructions_month}":"January",
  
                  // };
                  // // var mapObj = {
                  // //   "${f_subject_name}":"dog",
                  // //   dog:"goat",
                  // //   goat:"cat"
                  // //   };
                  // // str = str.replace(/cat|dog|goat/gi, function(matched){
                  // // return mapObj[matched];
                  // // });
  
  
  
                  // var re = new RegExp(Object.keys(mapObj).join("|"),"gi");
                  // str = str.replace(re, function(matched){
                  //   return mapObj[matched];
                  // });
                  // this.model.service_paragraph_rendered = re;
                  // this.attemptForm.controls['service_paragraph_rendered'].patchValue(re);
  
  
  
  
  
  
  
     
  
  
          // chosen Render/Merge Version local on page in javascript.  Rendered Pior to save.       
                  // Had to change tsconfig.json to make this work
                  // ::@https://www.geeksforgeeks.org/javascript-replace-multiple-strings-with-multiple-other-strings/
                  // https://stackoverflow.com/questions/63616486/property-replaceall-does-not-exist-on-type-string
                  /*
                      "lib": [
                      ...,
                      "ES2021.String"
                      ]
                  */
  
                      // This method we can l chosen to replace all variables for SubjectServiceOutcomeTemplate Merging - August 2023
                      // Add missing Logic here theat I apply in merge.php to return dates, names and other fields currently undefined.
  
  // UPPER CASE CONVERSIONS FRIST
  //  const job_registry_name = this.job_model.registry_name;
  //  const job_registry_name_UPPER = job_registry_name.toUpperCase() 
  // let subject_attempt_type_name =  this.subject_attempt_type.subject_attempt_type_name
  // const subject_attempt_type_name_UPPER = job_registry_name.toUpperCase() 
  
  
  
  
  // All if statements and check MUST run before ".replaceAll()"
  // Subject Name CHeck
  
  
  // Establish the Variables
  
  /*
  // Current Subject Variables.
  .replaceAll('${subject_id}', this.subject_model.subject_id)
  .replaceAll('${subject_number}', this.subject_model.subject_number)
  .replaceAll('${subject_job_status}', this.subject_model.job_status)
  
  
  // WHAT IF A BUSINESS NAME: RUNS ONCE REMEMBER OR DO I LOOP OVER TWO OR THREE TIMES TO ENSURE WE ARE MERGED?
  .replaceAll('${subject_name}', this.subject_model.first_name + ' ' + this.subject_model.middle_name + ' ' + this.subject_model.surname)
  .replaceAll('${subject_name_4_doc}', this.subject_model.first_name + '-' + this.subject_model.surname)
  .replaceAll('${subject_business_name}', this.subject_model.business_name)
  /*
  
  
  
  
  // Start Setup Variables
  
  /*Setp All Subject Varaibales as var_ objects - Variables that need if statemebts, all have to be Run and established prioler to .replaceAll!!!!!! August 2023 */
  let var_subject_id = this.subject_model.subject_id;
  let var_subject_number =  this.subject_model.subject_number;
  let var_subject_job_status =  this.subject_model.job_status;
  
  // Do checks for subject name / Businesss Name of FUll SUbject Name fields
  let var_subject_name =  this.subject_model.first_name + ' ' +  this.subject_model.middle_name + ' '+  this.subject_model.surname;
  let var_subject_name_4_doc = this.subject_model.first_name +'-'+  this.subject_model.surname;
  let var_subject_business_name =  this.subject_model.business_name;
  
  // Subject Name of Business
      if(var_subject_business_name != null){
          let var_trim_subject_business_name = var_subject_business_name.replaceAll(' ', ''); // need javscipt version of trim (all spaces removed)
          // $subject_name = $trim_subject_business_name;
           var_subject_name = var_subject_business_name; // changed here feb 2023 as subject busines name was printing stripped as variable in affidavid // Not trimmed
            var_subject_name_4_doc= var_trim_subject_business_name;
          
      }
  
  // Uppercese
  let var_job_registry_name = this.job_model.registry_name;
  if(var_job_registry_name != null){
  let var_job_registry_name_Upper = var_job_registry_name.toUpperCase();
  }
  
  
  // Current Attempt Variables Setups
  // Uppercase.

  // This was causing the paragraphs not to automatically render.....
  if(this.subject_attempt_type != undefined){
  let var_subject_attempt_type_name = this.subject_attempt_type.subject_attempt_type_name
  this.var_subject_attempt_type_name = var_subject_attempt_type_name;
  if(var_subject_attempt_type_name != null){ // uppercase must be validated if not null
   this.var_subject_attempt_type_name_Upper = var_subject_attempt_type_name.toUpperCase();
  }
}

  // service Methods.
  // let var_service_method_name = this.subject_service_method.service_method_name;
  if(this.subject_service_method != undefined){ // uppercase must be validated if not null // correct way is to check if the returned qiery is defined.
  this.var_service_method_name = this.subject_service_method.service_method_name;
  }
  // .replaceAll('${f_service_method_name}', this.subject_service_method.service_method_name ) // breaks if not exists
  
  
  // SAV -- subject relationship (checks if there is content and set the relationship or be null.)
  if(this.subject_service_fellow_relationship != null){
    this.subject_service_fellow_relationship  = this.subject_service_fellow_relationship.subject_relationship_name; 
  }
  
  // Variables 
  let var_subject_service_fellow_relationship =  this.subject_service_fellow_relationship;
  
  if(this.subjectServiceOutcome != undefined){
  this.var_service_outcome_name = this.subjectServiceOutcome.service_outcome_name;
  }
  // let var_service_outcome_name;
  
  // let var_location_status_name;
  
  
  if(this.subjectLocationStatus != undefined){
  this.var_location_status_name = this.subjectLocationStatus.location_status_name;
  }
  
  
  if(this.subjectAttemptPropertyType != undefined){
    this.var_property_type_name = this.subjectAttemptPropertyType.property_type_name
  }
  
  
  // let var_location_status_found_name;
  if(this.subjectLocationStatusFound != undefined){
  this.var_location_status_found_name = this.subjectLocationStatusFound.location_status_found_name;
  }
  
  if(this.subjectExactServiceMethod != undefined){
  // .replaceAll('${exact_service_method_name}', this.subjectExactServiceMethod.service_method_name
  // this.var_exact_service_method_name = this.subjectExactServiceMethod.service_method_name
  this.var_exact_service_method_name = this.subjectExactServiceMethod.exact_service_method_name
  
  
  }
  
  
  let var_subject_type_name;
  if(this.subject_job_subject_type != null){
  var_subject_type_name = this.subject_job_subject_type.job_subject_type_name
  } else{
  var_subject_type_name = '';
  }
  
 
  
// from save script above.
        // August 2023 - TimeZone Fixed Text
          // set a fixed time

          // commented out for testing of agent time zone changes.
          // THIS WAS CAUSING ISSUES WITH AGENTS CHANGING
                          // const dateTime = new Date(model.time_service).toLocaleTimeString('en-AU', {
                          //   hour: 'numeric', minute: 'numeric', hour12: true
                          //   });

                                          // GET THE TIME ZONE FROM THE SAVED FILE THIS IS THE FIX!@@@@@@@@@@@@@@ YESSSSS SYES  SYESSS
                            const dateTime = new Date(model.time_service).toLocaleTimeString('em-AU', {
                              hour: 'numeric', minute: 'numeric', hour12: true , timeZone: model.service_local
                              });
  

                              // const dateTime = new Date(model.time_service)

                          // this.model.time_service_text = this.mytime;
       
                          // Attempt to change variables back to model variables and just leave as is....
                                          // this.model.time_service_text = dateTime;
                                          // model.time_service_text = dateTime;

                          //  this.model.time_service_text = model.time_service_text
                          // model.time_service_text = model.time_service_text

// NEED TO ADD NEW TIMEZONE HERE AS
// Modified October 2023 to fix new entry for time & dates
if(model.time_service_text != ''){
  // set the time_service to to the new time.
  this.var_time_service = model.time_service_text;
}else{
  this.var_time_service = model.time_service;
}


  
          // // first check if exists to prevent load errors
          // if(model.subject_service_outcome_id){
          //  var_service_outcome_name = this.subjectServiceOutcome.service_outcome_name;
          // }
  
          // if(model.subject_location_status_id){
          //  var_location_status_name = this.subjectLocationStatus.location_status_name;
          //  }
  
  
          //  if(model.subject_location_status_found_id){
          //   var_location_status_found_name = this.subjectLocationStatusFound.location_status_found_name;
          //  }
          
  
  // Start Replace All (Starts to replace everyting below.. One continuus proceedure.)
  
  
  // Run this before Replace all strins
  function runReplaceSubjectName(string){
    const search = ' ';
    const replace = '-';
    const result = string.replace(search, replace);
    return result;
    }
  
  
  
   
  
  
  // TIP:: SIMPLY CHANGE THE VARAIBLES IF YOU REQUIRE HTML RENDERED FORMATTING etc... to align with interface in SO/Service Card.
  // As Plain Text
  // Sets the string to be replaced.
  // const str2 = data.ssot_template_WORD;
  const str2 = data.ssot_template_HTML; // change3 me for frull HTNL variables
  
  
  // Fallback in case I have not created plain TExt.
  // Sets the string to be replaced.
  if(data.ssot_template_WORD == null){
  const str2 = data.ssot_template_HTML;
  }
  
  
  
  // New test to run function below to convert the variable
  
  // need all the variables to be loaded first for this to work correctly
  
  // let str3 = runMergeVariables(data.ssot_template_HTML)
  
  // new function to run over any string and retrn string with merged variables initiated.
  

  // END NEW EXPERIMENTAL FUNCTION
  
  
  // Function to remove when HTML in Place -- This allows general notes to be set by either if the HTML field is hidden
if(model.general_notes_HTML == null){
  this.set_general_notes = model.general_notes;
  }else{
   this.set_general_notes = this.stripTagsP(unescape(this.transform2(model.general_notes_HTML))) // remve paragraphs while rendiering...
  }
  
if(model.property_type_details_HTML == null){this.set_property_type_details_HTML = model.property_type_details; }else{this.set_property_type_details_HTML = this.stripTagsP(unescape(this.transform2(model.property_type_details_HTML)));}
if(model.property_occupied_details_HTML == null){this.property_occupied_details_HTML = model.property_occupied_details; }else{this.property_occupied_details_HTML = this.stripTagsP(unescape(this.transform2(model.property_occupied_details_HTML)));}
if(model.property_forsale_or_lease_sign_details_HTML == null){this.property_forsale_or_lease_sign_details_HTML = model.property_forsale_or_lease_sign_details; }else{this.property_forsale_or_lease_sign_details_HTML = this.stripTagsP(unescape(this.transform2(model.property_forsale_or_lease_sign_details_HTML)));}  
  
if(model.property_mail_details_HTML == null){this.property_mail_details_HTML = model.property_mail_details; }else{this.property_mail_details_HTML = this.stripTagsP(unescape(this.transform2(model.property_mail_details_HTML)));}

if(model.property_vehicles_sighted_details_HTML == null){this.property_vehicles_sighted_details_HTML = model.property_vehicles_sighted_details; }else{this.property_vehicles_sighted_details_HTML = this.stripTagsP(unescape(this.transform2(model.property_vehicles_sighted_details_HTML)));}  

if(model.property_pets_details_HTML == null){this.property_pets_details_HTML = model.property_pets_details; }else{this.property_pets_details_HTML = this.stripTagsP(unescape(this.transform2(model.property_pets_details_HTML)));}

if(model.property_occupancy_details_HTML == null){this.property_occupancy_details_HTML = model.property_occupancy_details; }else{this.property_occupancy_details_HTML = this.stripTagsP(unescape(this.transform2(model.property_occupancy_details_HTML)));}

if(model.property_condition_HTML == null){this.property_condition_HTML = model.property_condition; }else{this.property_condition_HTML = this.stripTagsP(unescape(this.transform2(model.property_condition_HTML)));}

if(model.attempts_notes_HTML == null){this.attempts_notes_HTML = model.attempts_notes; }else{this.attempts_notes_HTML = this.stripTagsP(unescape(this.transform2(model.attempts_notes_HTML)));}

if(model.person_spoken_with_advised_HTML == null){this.person_spoken_with_advised_HTML = model.person_spoken_with_advised; }else{this.person_spoken_with_advised_HTML = this.stripTagsP(unescape(this.transform2(model.person_spoken_with_advised_HTML)));}

if(model.vehicles_notes_HTML == null){this.vehicles_notes_HTML = model.vehicles_notes; }else{this.vehicles_notes_HTML = this.stripTagsP(unescape(this.transform2(model.vehicles_notes_HTML)));}

if(model.neighbours_notes_HTML == null){this.neighbours_notes_HTML = model.neighbours_notes; }else{this.neighbours_notes_HTML = this.stripTagsP(unescape(this.transform2(model.neighbours_notes_HTML)));}

if(model.calling_card_notes_HTML == null){this.calling_card_notes_HTML = model.calling_card_notes; }else{this.calling_card_notes_HTML = this.stripTagsP(unescape(this.transform2(model.calling_card_notes_HTML)));}

if(model.postal_mail_notes_HTML == null){this.postal_mail_notes_HTML = model.postal_mail_notes; }else{this.postal_mail_notes_HTML = this.stripTagsP(unescape(this.transform2(model.postal_mail_notes_HTML)));}

if(model.phone_call_notes_HTML == null){this.phone_call_notes_HTML = model.phone_call_notes; }else{this.phone_call_notes_HTML = this.stripTagsP(unescape(this.transform2(model.phone_call_notes_HTML)));}


if(model.email_contents_HTML == null){this.email_contents_HTML = model.email_contents; }else{this.email_contents_HTML = this.stripTagsP(unescape(this.transform2(model.email_contents_HTML)));}
  
if(model.service_under_order_HTML == null){this.service_under_order_HTML = model.service_under_order; }else{this.service_under_order_HTML = this.stripTagsP(unescape(this.transform2(model.service_under_order_HTML)));}

// New null print edition May 2024
let vehicles = model.vehicles;
if(vehicles == 'Our agent observed the following vehicles at the address.'){
  vehicles = ''; // empty for the negative
}else{
  vehicles = model.vehicles;
};

let neighbours = model.neighbours;
if(neighbours == 'Our agent was able to speak to neighbours and had the following conversation.'){
  neighbours = ''; // empty for the negative
}else{
  neighbours = model.neighbours;
};

let calling_card = model.calling_card;
// if(calling_card == 'A calling card was left at the address.'){
//   calling_card = ''; // empty for the negative
// }else{
//   calling_card = model.calling_card;
// };

let postal_mail = model.postal_mail;
if(postal_mail == 'Our agent sighted mail at the address and provided the following further information.'){
  postal_mail = ''; // empty for the negative
}else{
  postal_mail = model.postal_mail;
};

let phone_call = model.phone_call;
if(phone_call == 'A phone call was made'){
  phone_call = ''; // empty for the negative
}else{
  phone_call = model.phone_call;
};


  const rendered_result = str2
      // .replaceAll('${f_subject_name}', 'Big Subject')
      // .replaceAll('${f_subject_number}', this.subject_model.subject_number)
      // .replaceAll('${job_instructions_month}', 'January')
      // .replaceAll('${job_instructions_day_number} ', '56')
      // .replaceAll('${job_instructions_year}', this.job_model.job_instructions_year)
  
  // Start of officual Job Vars
  .replaceAll('${job_id}', this.job_model.job_id)
  .replaceAll('${job_number}', this.job_model.job_number)
  .replaceAll('${job_status_code}', this.job_model.job_status_code)
  .replaceAll('${owner_trace_code}', this.job_model.owner_trace_code)
  .replaceAll('${client_ref}', this.job_model.owner_trace_code)
  .replaceAll('${client_reference}', this.job_model.owner_trace_code)
  .replaceAll('${job_document_number}', this.job_model.document_number)
  .replaceAll('${job_registry_name}', this.job_model.registry_name)
  // .replaceAll('${job_registry_name_upper}', job_registry_name_UPPER) // set variables before replaceAll Function
  
  .replaceAll('${job_hearing_date}', this.job_model.hearing_date)
  .replaceAll('${hearing_date_full_words_time_first}', this.legalDate.format(this.job_model.hearing_date, 'h:mma dddd MMMM Do, YYYY') ) // equivilent to in PHP :: date("g:ia l jS F Y", strtotime($job_hearing_date))
  .replaceAll('${hearing_date_full_words}', this.legalDate.format(this.job_model.hearing_date, 'dddd MMMM Do, YYYY h:mma') )
  .replaceAll('${hearing_date}', this.legalDate.format(this.job_model.hearing_date, 'M/D/YYYY'))
  .replaceAll('${hearing_day}', this.legalDate.format(this.job_model.hearing_date, 'dddd'))
  .replaceAll('${hearing_day_number}', this.legalDate.format(this.job_model.hearing_date, 'Do'))
  .replaceAll('${hearing_month}', this.legalDate.format(this.job_model.hearing_date, 'MMMM'))
  .replaceAll('${hearing_month_number}', this.legalDate.format(this.job_model.hearing_date, 'Mo'))
  .replaceAll('${hearing_month_number_simple}', this.legalDate.format(this.job_model.hearing_date, 'M'))
  .replaceAll('${hearing_year}', this.legalDate.format(this.job_model.hearing_date, 'YYYY'))
  .replaceAll('${hearing_time}', this.legalDate.format(this.job_model.hearing_date, 'h:mma'))
  
  .replaceAll('${job_judgement_date}', this.legalDate.format(this.job_model.judgement_date, 'M/D/YYYY'))
  .replaceAll('${judgement_date_full_words_time_first}', this.legalDate.format(this.job_model.judgement_date, 'h:mma dddd MMMM Do, YYYY') ) 
  .replaceAll('${judgement_date_full_words}', this.legalDate.format(this.job_model.judgement_date, 'h:mma dddd MMMM Do, YYYY') ) 
  .replaceAll('${judgement_date}', this.legalDate.format(this.job_model.judgement_date, 'M/D/YYYY'))
  .replaceAll('${judgement_day}', this.legalDate.format(this.job_model.judgement_date, 'dddd'))
  .replaceAll('${judgement_day_number}', this.legalDate.format(this.job_model.judgement_date, 'Do'))
  .replaceAll('${judgement_month}', this.legalDate.format(this.job_model.judgement_date, 'MMMM'))
  .replaceAll('${judgement_month_number}', this.legalDate.format(this.job_model.judgement_date, 'Mo'))
  .replaceAll('${judgement_month_number_simple}', this.legalDate.format(this.job_model.judgement_date, 'M'))
  .replaceAll('${judgement_year}', this.legalDate.format(this.job_model.judgement_date, 'YYYY'))
  .replaceAll('${judgement_time}', this.legalDate.format(this.job_model.judgement_date, 'h:mma'))
  
  .replaceAll('${job_filing_date}', this.legalDate.format(this.job_model.filing_date, 'M/D/YYYY'))
  .replaceAll('${filing_date_full_words_time_first}', this.legalDate.format(this.job_model.filing_date, 'h:mma dddd MMMM Do, YYYY') ) 
  .replaceAll('${filing_date_full_words}', this.legalDate.format(this.job_model.filing_date, 'h:mma dddd MMMM Do, YYYY') ) 
  .replaceAll('${filing_date}', this.legalDate.format(this.job_model.filing_date, 'M/D/YYYY'))
  .replaceAll('${filing_day}', this.legalDate.format(this.job_model.filing_date, 'dddd'))
  .replaceAll('${filing_day_number}', this.legalDate.format(this.job_model.filing_date, 'Do'))
  .replaceAll('${filing_month}', this.legalDate.format(this.job_model.filing_date, 'MMMM'))
  .replaceAll('${filing_month_number}', this.legalDate.format(this.job_model.filing_date, 'Mo'))
  .replaceAll('${filing_month_number_simple}', this.legalDate.format(this.job_model.filing_date, 'M'))
  .replaceAll('${filing_year}', this.legalDate.format(this.job_model.filing_date, 'YYYY'))
  .replaceAll('${filing_time}', this.legalDate.format(this.job_model.filing_date, 'h:mma'))
  
  
  .replaceAll('${job_instructions_date}', this.legalDate.format(this.job_model.instructions_date, 'M/D/YYYY'))
  .replaceAll('${instructions_date_full_words_time_first}', this.legalDate.format(this.job_model.instructions_date, 'h:mma dddd MMMM Do, YYYY') ) 
  .replaceAll('${instructions_date_full_words}', this.legalDate.format(this.job_model.instructions_date, 'h:mma dddd MMMM Do, YYYY') ) 
  .replaceAll('${instructions_date}', this.legalDate.format(this.job_model.instructions_date, 'M/D/YYYY'))
  .replaceAll('${instructions_day}', this.legalDate.format(this.job_model.instructions_date, 'dddd'))
  .replaceAll('${instructions_day_number}', this.legalDate.format(this.job_model.instructions_date, 'Do'))
  .replaceAll('${instructions_month}', this.legalDate.format(this.job_model.instructions_date, 'MMMM'))
  .replaceAll('${instructions_month_number}', this.legalDate.format(this.job_model.instructions_date, 'Mo'))
  .replaceAll('${instructions_month_number_simple}', this.legalDate.format(this.job_model.instructions_date, 'M'))
  .replaceAll('${instructions_year}', this.legalDate.format(this.job_model.instructions_date, 'YYYY'))
  .replaceAll('${instructions_time}', this.legalDate.format(this.job_model.instructions_date, 'h:mma'))
  
  .replaceAll('${job_aos_date}', this.legalDate.format(this.job_model.aos_date, 'M/D/YYYY'))
  .replaceAll('${aos_date_full_words_time_first}', this.legalDate.format(this.job_model.aos_date, 'h:mma dddd MMMM Do, YYYY') ) 
  .replaceAll('${aos_date_full_words}', this.legalDate.format(this.job_model.aos_date, 'h:mma dddd MMMM Do, YYYY') ) 
  .replaceAll('${aos_date}', this.legalDate.format(this.job_model.aos_date, 'M/D/YYYY'))
  .replaceAll('${aos_day}', this.legalDate.format(this.job_model.aos_date, 'dddd'))
  .replaceAll('${aos_day_number}', this.legalDate.format(this.job_model.aos_date, 'Do'))
  .replaceAll('${aos_month}', this.legalDate.format(this.job_model.aos_date, 'MMMM'))
  .replaceAll('${aos_month_number}', this.legalDate.format(this.job_model.aos_date, 'Mo'))
  .replaceAll('${aos_month_number_simple}', this.legalDate.format(this.job_model.aos_date, 'M'))
  .replaceAll('${aos_year}', this.legalDate.format(this.job_model.aos_date, 'YYYY'))
  .replaceAll('${aos_time}', this.legalDate.format(this.job_model.aos_date, 'h:mma'))
  
  // Current Attempt Variables
  .replaceAll('${f_attempt_type_id}', model.subject_attempt_type_id)
  .replaceAll('${f_attempt_type_name}', this.var_subject_attempt_type_name ) // run a function with return;
  .replaceAll('${f_attempt_type_name_upper}', this.var_subject_attempt_type_name_Upper) // all if statments set a this/g/ varaibales
  .replaceAll('${type_id}', model.subject_attempt_type_id)
  .replaceAll('${type_name}', this.var_subject_attempt_type_name ) // run a function with return;
  .replaceAll('${type_name_upper}', this.var_subject_attempt_type_name_Upper) // all if statments set a this/g/ varaibales
  
  .replaceAll('${f_attempt_subject_type_id}', model.subject_attempt_type_id)
  .replaceAll('${f_attempt_subject_type_name}', this.var_subject_attempt_type_name ) // run a function with return;
  .replaceAll('${f_attempt_subject_type_name_upper}', this.var_subject_attempt_type_name_Upper) // all if statments set a this/g/ varaibales
  .replaceAll('${subject_type_id}', model.subject_attempt_type_id)
  .replaceAll('${subject_type_name}', this.var_subject_attempt_type_name ) // run a function with return;
  .replaceAll('${subject_type_name_upper}', this.var_subject_attempt_type_name_Upper) // all if statments set a this/g/ varaibales
  
  .replaceAll('${f_service_method_id}', model.subject_service_method_id)
  .replaceAll('${f_service_method_name}', this.var_service_method_name ) // tested above.
  .replaceAll('${service_method_id}', model.subject_service_method_id)
  .replaceAll('${service_method_name}', this.var_service_method_name ) // tested above.
  
  .replaceAll('${f_attempt_service_method_id}', model.subject_service_method_id)
  .replaceAll('${f_attempt_service_method_name}', this.var_service_method_name ) // tested above.
  
  // SAV
  .replaceAll('${sav_service_method}', this.var_service_method_name ) // tested above.
  
  
  
  
  
  
// Attempt and Service Dates and Times
.replaceAll('${date_service}', moment(model.date_service).format('M/D/YYYY'))

// New Local Times with Full Date.
// .replaceAll('${date_service_full_words_time_first}', moment(this.job_model.date_service).format('h:mma dddd MMMM Do, YYYY') ) // 

.replaceAll('${date_service_full_words_time_first}', model.time_service_text + ' ' + moment(model.date_service).format('dddd MMMM Do, YYYY') ) // 
// .replaceAll('${date_service_full_words}', moment(this.job_model.date_service).format('h:mma dddd MMMM Do, YYYY') ) 
// + ' ' + model.time_service_text 
.replaceAll('${date_service_full_words}', moment(model.date_service).format('dddd MMMM Do, YYYY') ) 

.replaceAll('${date_service_and_time_full_words}', moment(model.date_service).format('dddd MMMM Do, YYYY') + ' ' + model.time_service_text   ) // 

.replaceAll('${day}', moment(model.date_service).format('dddd'))
.replaceAll('${day_number}', moment(model.date_service).format('Do'))
.replaceAll('${day_number_simple}', moment(model.date_service).format('D'))
.replaceAll('${month}', moment(model.date_service).format('MMMM'))
.replaceAll('${month_number}', moment(model.date_service).format('Mo'))
.replaceAll('${month_number_simple}', moment(model.date_service).format('M'))
.replaceAll('${year}', moment(model.date_service).format('YYYY'))

.replaceAll('${service_local}', model.service_local) // region Australia/Perth of service undertaken

// Replace above to choose correct Times. // Testing this for correct paragraph times and dates.
// .replaceAll('${time}', model.time_service_text) //$_set_service_time - Fixed and set time of attempt and service
.replaceAll('${time}', this.var_time_service) //$_set_service_time - Fixed and set time of attempt and service

// SAV
.replaceAll('${sav_service_day}', moment(model.date_service).format('dddd'))
.replaceAll('${sav_service_day_number}', moment(model.date_service).format('Do'))
.replaceAll('${sav_service_day_number}', moment(model.date_service).format('Do'))

.replaceAll('${sav_service_day_number_simple}', moment(model.date_service).format('D'))
.replaceAll('${sav_service_month}', moment(model.date_service).format('MMMM'))
.replaceAll('${sav_service_month_number}', moment(model.date_service).format('Mo'))
.replaceAll('${sav_service_month_number_simple}', moment(model.date_service).format('M'))
.replaceAll('${sav_service_year}', moment(model.date_service).format('YYYY'))

.replaceAll('${sav_service_service_local}', model.service_local) // region Australia/Perth of service undertaken


// .replaceAll('${sav_time_service}', model.time_service_text) //$_set_service_time - Fixed and set time of attempt and service
.replaceAll('${sav_time_service}', this.var_time_service) //$_set_service_time - Fixed and set time of attempt and service

.replaceAll('${sav_director_name}', model.director_name)
  
  
  // Subject Attempt Address
  .replaceAll('${address_1}', model.address_1)
  .replaceAll('${address_2}', model.address_2)
  .replaceAll('${suburb}', model.suburb)
  .replaceAll('${state}', model.state)
  .replaceAll('${postcode}', model.postcode)
  .replaceAll('${address_full}', model.address_1 +  ' ' + model.address_2 +  ' ' + model.suburb +  ' ' + model.state +  ',  ' + model.postcode )
  // Sav
  .replaceAll('${sav_address_full}', model.address_1 +  ' ' + model.address_2 +  ' ' + model.suburb +  ' ' + model.state +  ',  ' + model.postcode )
  // New address
  .replaceAll('${new_business_name}', model.new_business_name)
  .replaceAll('${new_address_1}', model.new_address_1)
  .replaceAll('${new_address_2}', model.new_address_2)
  .replaceAll('${new_suburb}', model.new_suburb)
  .replaceAll('${new_state}', model.new_state)
  .replaceAll('${new_postcode}', model.new_postcode)
  .replaceAll('${new_address_full}', model.new_address_1 +  ' ' + model.new_address_2 +  ' ' + model.new_suburb +  ' ' + model.new_state +  ',  ' + model.new_postcode )
  
  .replaceAll('${service_number}', model.service_number)
  
  
  
  // These may be different for attendances and servives ??? need to check. and crate as variable in an if satement above if true.
  .replaceAll('${fellow_occupants_name}', model.fellow_occupants_name)
  .replaceAll('${sav_fellow_occupants_name}', model.fellow_occupants_name)
  .replaceAll('${fellow_occupants_sex}', model.fellow_occupants_sex)
  // changed october 2023
  // .replaceAll('${fellow_occupants_name}', model.person_spoken_with)
  // .replaceAll('${sav_fellow_occupants_name}', model.person_spoken_with)
  // .replaceAll('${fellow_occupants_sex}', model.person_type)
  .replaceAll('${fellow_occupants_name_label}', 'Fellow Occupants Name: ' +  model.fellow_occupants_name)
  
  
  .replaceAll('${person_spoken_with}', model.person_spoken_with)
  .replaceAll('${person_type}', model.person_type)
// .replaceAll('${person_spoken_with_advised}', model.person_spoken_with_advised)
// .replaceAll('${person_spoken_with_advised}',   unescape(this.transform2(model.person_spoken_with_advised_HTML)) ) 
.replaceAll('${person_spoken_with_advised}',   this.person_spoken_with_advised_HTML ) 
  .replaceAll('${vehicles}', vehicles)
// .replaceAll('${vehicles_notes}', model.vehicles_notes)
// .replaceAll('${vehicles_notes}',   unescape(this.transform2(model.vehicles_notes_HTML)) ) // replace original only use this for create.
.replaceAll('${vehicles_notes}',   this.vehicles_notes_HTML ) // replace original only use this for create.
  .replaceAll('${neighbours}', neighbours)
  // .replaceAll('${neighbours_notes}', model.neighbours_notes)
// .replaceAll('${neighbours_notes}',   unescape(this.transform2(model.neighbours_notes_HTML)) ) // replace original only use this for create.
.replaceAll('${neighbours_notes}',   this.neighbours_notes_HTML ) // replace original only use this for create.
  .replaceAll('${calling_card}', calling_card)
// .replaceAll('${calling_card_notes}', model.calling_card_notes)
// .replaceAll('${calling_card_notes}',   unescape(this.transform2(model.calling_card_notes_HTML)) ) // replace original only use this for create.
.replaceAll('${calling_card_notes}',   this.calling_card_notes_HTML ) // replace original only use this for create.
  .replaceAll('${postal_mail}', postal_mail)
// .replaceAll('${postal_mail_notes}', model.postal_mail_notes)
// .replaceAll('${postal_mail_notes}',   unescape(this.transform2(model.postal_mail_notes_HTML)) ) // replace original only use this for create.
.replaceAll('${postal_mail_notes}',   this.postal_mail_notes_HTML ) // replace original only use this for create.
  .replaceAll('${phone_call}', phone_call)
  // .replaceAll('${phone_call_notes}', model.phone_call_notes)
// .replaceAll('${phone_call_notes}',   unescape(this.transform2(model.phone_call_notes_HTML)) ) // replace original only use this for create.
.replaceAll('${phone_call_notes}',   this.phone_call_notes_HTML ) // replace original only use this for create.
  .replaceAll('${attempts}', model.attempts)
// .replaceAll('${attempts_notes}', model.attempts_notes)
// .replaceAll('${attempts_notes}',   unescape(this.transform2(model.attempts_notes_HTML)) ) // replace original only use this for create.
.replaceAll('${attempts_notes}',   this.attempts_notes_HTML ) // replace original only use this for create.
  .replaceAll('${authorised_employee_name}', model.authorised_employee_name)
  .replaceAll('${authorised_employee_job_title}', model.authorised_employee_job_title)
  .replaceAll('${authorised_employee_sex}', model.authorised_employee_sex)
  .replaceAll('${office_business_name}', model.office_business_name)
  
  .replaceAll('${witness_name}', model.witness_name)
  .replaceAll('${witness_business_name}', model.witness_business_name)
  .replaceAll('${witness_address}', model.witness_address_1 + ' ' + model.witness_address_2 + ' ' +  model.witness_suburb + ' ' + model.witness_state + ', ' + model.witness_postcode  ) // 
  
  .replaceAll('${witness_address_1}', model.witness_address_1)
  .replaceAll('${witness_address_2}', model.witness_address_2)
  .replaceAll('${witness_state}', model.witness_state)
  .replaceAll('${witness_suburb}', model.witness_suburb)
  .replaceAll('${witness_country}', model.witness_country)
  .replaceAll('${witness_postcode}', model.witness_postcode)
  
  .replaceAll('${person_in_charge_of_prison_name}', model.person_in_charge_of_prison_name)
  .replaceAll('${person_in_charge_of_prison_occupation}', model.person_in_charge_of_prison_occupation)
  .replaceAll('${subject_contact_email_id}', model.subject_contact_email_id)
  .replaceAll('${email_address_served}', model.email_address_served)
  .replaceAll('${director_name}', model.director_name)
  // .replaceAll('${service_under_order}', model.service_under_order)
  
  .replaceAll('${business_name}', model.business_name)
  .replaceAll('${f_service_business_name}', model.business_name)
  
  // .replaceAll('${general_notes}', model.general_notes) // old system pre Nov 23
// .replaceAll('${general_notes}',   unescape(this.transform2(model.general_notes_HTML)) ) // replace original only use this for create.
.replaceAll('${general_notes}',  this.set_general_notes ) // replace original only use this for create.

     // New HTML Varibles

     // Might have to create a PHP Function to decode the variable...  I could always try the other function.
    //  .replaceAll('${general_notes_HTML}', document.getElementById('general_notes_HTML').innerText ) // needs to be decoded? // see new function
    
    // .replaceAll('${general_notes_HTML}',  unescape(model.general_notes_HTML)) // needs to be decoded? // see new function - this decodes but leaves all the HTML div tags and content
    
     //  .replaceAll('${general_notes_HTML}',  this.escapeHtml(unescape(model.general_notes_HTML))) // needs to be decoded? // see new function
   
    // .replaceAll('${general_notes_HTML}',  decodeURIComponent(model.general_notes_HTML)) // needs to be decoded? // see new function

    
    //  .replaceAll('${general_notes_HTML}',  ) // needs to be decoded? // see new function THIS WORKS but requires a hidden field in the template
    // .replaceAll('${general_notes_HTML}',  document.getElementById('general_notes_HTML_rendered_hidden').innerHTML ) // needs to be decoded? // see new function - this one gets the rendered HTML from a hidden fied on the page and (unner text only) and sets as the variable.

      // :: Try getting the field without having to create a hidden field.
      .replaceAll('${general_notes_HTML}',   unescape(this.transform2(model.general_notes_HTML)) ) // needs to be decoded? // see new function - this one gets the rendered HTML from a hidden fied on the page and (unner text only) and sets as the variable.
    
     

    
  // .replaceAll('${email_contents}', model.email_contents)
// .replaceAll('${email_contents}', unescape(this.transform2(model.email_contents_HTML)) ) // replace original only use this for create.
.replaceAll('${email_contents}', this.email_contents_HTML ) // replace original only use this for create.
.replaceAll('${service_under_order}', this.service_under_order_HTML ) // replace original only use this for create.
.replaceAll('${service_under_order_HTML}', this.service_under_order_HTML ) // replace original only use this for create.

  .replaceAll('${phone_number}', model.phone_number)
  .replaceAll('${is_count}', model.is_count)
  .replaceAll('${property_images}', model.property_images)
  .replaceAll('${attach_file_array_name}', model.attach_file_array_name)
  .replaceAll('${property_occupied}', model.property_occupied)
  .replaceAll('${property_forsale_or_lease_sign}', model.property_forsale_or_lease_sign)
  .replaceAll('${property_sign_images}', model.property_sign_images)
// .replaceAll('${property_forsale_or_lease_sign_details}', model.property_forsale_or_lease_sign_details)
// .replaceAll('${property_forsale_or_lease_sign_details}',   unescape(this.transform2(model.property_forsale_or_lease_sign_details_HTML)) ) // replace original only use this for create.
.replaceAll('${property_forsale_or_lease_sign_details}',   this.property_forsale_or_lease_sign_details_HTML) // replace original only use this for create.
  .replaceAll('${property_agent_name}', model.property_agent_name)
  .replaceAll('${property_agency_name}', model.property_agency_name)
  .replaceAll('${property_agency_contact_numbers}', model.property_agency_contact_numbers)
  .replaceAll('${property_mail}', model.property_mail)
  .replaceAll('${property_mail_images}', model.property_mail_images)
// .replaceAll('${property_mail_details}', model.property_mail_details)
// .replaceAll('${property_mail_details}', unescape(this.transform2(model.property_mail_details_HTML)) ) // replace original only use this for create.
.replaceAll('${property_mail_details}', this.property_mail_details_HTML ) // replace original only use this for create.
  .replaceAll('${property_vehicles_sighted}', model.property_vehicles_sighted)
// .replaceAll('${property_vehicles_sighted_details}', model.property_vehicles_sighted_details)
// .replaceAll('${property_vehicles_sighted_details}', unescape(this.transform2(model.property_vehicles_sighted_details_HTML)) ) // replace original only use this for create.
.replaceAll('${property_vehicles_sighted_details}', this.property_vehicles_sighted_details_HTML ) // replace original only use this for create.
  .replaceAll('${property_vehicles_images}', model.property_vehicles_images)
  .replaceAll('${property_v_make}', model.property_v_make)
  .replaceAll('${property_v_model}', model.property_v_model)
  .replaceAll('${property_v_plate}', model.property_v_plate)
  .replaceAll('${property_v_rego_state}', model.property_v_rego_state)
  .replaceAll('${property_pets}', model.property_pets)
// .replaceAll('${property_pets_details}', model.property_pets_details)
// .replaceAll('${property_pets_details}', unescape(this.transform2(model.property_pets_details_HTML)) ) // replace original only use this for create.
.replaceAll('${property_pets_details}', this.property_pets_details_HTML ) // replace original only use this for create.
  .replaceAll('${property_pets_images}', model.property_pets_images)
  .replaceAll('${property_occupancy}', model.property_occupancy)
// .replaceAll('${property_occupancy_details}', model.property_occupancy_details)
// .replaceAll('${property_occupancy_details}', unescape(this.transform2(model.property_occupancy_details_HTML)) ) // replace original only use this for create.
.replaceAll('${property_occupancy_details}', this.property_occupancy_details_HTML ) // replace original only use this for create.
  .replaceAll('${property_occupancy_images}', model.property_occupancy_images)
  .replaceAll('${property_o_name}', model.property_o_name)
  .replaceAll('${property_o_contact_numbers}', model.property_o_contact_numbers)
  .replaceAll('${property_o_lease_details}', model.property_o_lease_details)
  .replaceAll('${property_o_lease_date}', model.property_o_lease_date)
  .replaceAll('${property_o_landlord_contacts}', model.property_o_landlord_contacts)
// .replaceAll('${property_condition}', model.property_condition)
// .replaceAll('${property_condition}', unescape(this.transform2(model.property_condition_HTML)) ) // replace original only use this for create.
.replaceAll('${property_condition}', this.property_condition_HTML ) // replace original only use this for create.
  .replaceAll('${property_condition_images}', model.property_condition_images)
// .replaceAll('${property_occupied_details}', model.property_occupied_details)
// .replaceAll('${property_occupied_details}', unescape(this.transform2(model.property_occupied_details_HTML)) ) // replace original only use this for create.
.replaceAll('${property_occupied_details}', this.property_occupied_details_HTML) // replace original only use this for create.
  .replaceAll('${property_type_id}', model.property_type_id)
  
  
// .replaceAll('${property_type_details}', model.property_type_details)
// .replaceAll('${property_type_details}', unescape(this.transform2(model.property_type_details_HTML)) ) // replace original only use this for create.
.replaceAll('${property_type_details}', this.set_property_type_details_HTML) // replace original only use this for create.
  .replaceAll('${property_type_images}', model.property_type_images)
  
    // Missing Report Client Name - And Report Client Details for the paragraph
    .replaceAll('${job_report_client_name}', this.job_report_client.name)
    .replaceAll('${job_client_report_name}', this.job_report_client.name)
    .replaceAll('${job_client_report_name_upper}', this.job_report_client.name)
  
    .replaceAll('${job_client_report_phone}', this.job_report_client.phone)
    .replaceAll('${job_client_report_address_1}', this.job_report_client.address_1)
    .replaceAll('${job_client_report_address_2}', this.job_report_client.address_2)
    .replaceAll('${job_client_report_suburb}', this.job_report_client.suburb)
    .replaceAll('${job_client_report_state}', this.job_report_client.state)
    .replaceAll('${job_client_report_postcode}', this.job_report_client.postcode)
    .replaceAll('${job_client_report_country}', this.job_report_client.country)
    .replaceAll('${job_client_report_brand_type_id}', this.job_report_client.brand_type_id)
    .replaceAll('${job_client_report_notes}', this.job_report_client.brand_notes)
    .replaceAll('${job_client_report_fax}', this.job_report_client.fax)
    .replaceAll('${job_client_report_email}', this.job_report_client.email)
    .replaceAll('${job_client_report_website}', this.job_report_client.website)
    .replaceAll('${job_client_report_postal_address_1}', this.job_report_client.postal_address_1)
    .replaceAll('${job_client_report_postal_address_2}', this.job_report_client.postal_address_2)
    .replaceAll('${job_client_report_postal_suburb}', this.job_report_client.postal_suburb)
    .replaceAll('${job_client_report_postal_state}', this.job_report_client.postal_state)
    .replaceAll('${job_client_report_postal_postcode}', this.job_report_client.postal_postcode)
    .replaceAll('${job_client_report_postal_country}', this.job_report_client.postal_country)
    .replaceAll('${job_client_report_myob_id}', this.job_report_client.myob_id)
    .replaceAll('${job_client_report_accounts_email_address}', this.job_report_client.accounts_email_address)
    .replaceAll('${job_client_report_brand_type}', this.job_report_client.brand_type_id)
  
  
  
  // Agent Details
  .replaceAll('${agent_name}', this.subject_service_agent.first_name + ' ' + this.subject_service_agent.middle_name + ' ' + this.subject_service_agent.surname )
  .replaceAll('${agent_first_name}', this.subject_service_agent.first_name)
  .replaceAll('${agent_middle_name}', this.subject_service_agent.middle_name)
  .replaceAll('${agent_surname}', this.subject_service_agent.surname)
  
  .replaceAll('${agent_address_1}', this.subject_service_agent.address_1)
  .replaceAll('${agent_address_2}', this.subject_service_agent.address_2)
  .replaceAll('${agent_suburb}', this.subject_service_agent.suburb)
  .replaceAll('${agent_state}', this.subject_service_agent.state)
  .replaceAll('${agent_postcode}', this.subject_service_agent.postcode)
  .replaceAll('${agent_address_full}', this.subject_service_agent.address_1 + ' ' + this.subject_service_agent.address_2 + ' ' + this.subject_service_agent.suburb + ' ' + this.subject_service_agent.state + ', ' + this.subject_service_agent.postcode )
  .replaceAll('${agent_qualification}', this.subject_service_agent.qualification)
  .replaceAll('${agent_qualification_number}', this.subject_service_agent.qualification_number)
  
  .replaceAll('${agent_qualification_renewal_date}', moment(this.subject_service_agent.qualification_renewal_date).format('M/D/YYYY') )
  .replaceAll('${agent_qualification_renewal_date_full_words}', moment(this.subject_service_agent.qualification_renewal_date).format('dddd MMMM Do, YYYY h:mma') )
  
  // CHANGE ThESE to variables not direct connectins to the model so I can minipulate and check before running the replace
  // Current Subject Variables.
  // .replaceAll('${subject_id}', this.subject_model.subject_id)
  // .replaceAll('${subject_number}', this.subject_model.subject_number)
  // .replaceAll('${subject_job_status}', this.subject_model.job_status)
  
  // WHAT IF A BUSINESS NAME: RUNS ONCE REMEMBER OR DO I LOOP OVER TWO OR THREE TIMES TO ENSURE WE ARE MERGED?
  // .replaceAll('${subject_name}', this.subject_model.first_name + ' ' + this.subject_model.middle_name + ' ' + this.subject_model.surname)
  // .replaceAll('${subject_name_4_doc}', this.subject_model.first_name + '-' + this.subject_model.surname)
  // .replaceAll('${subject_business_name}', this.subject_model.business_name)
  
  
  
  // Changed to varaibles.
  // Subject Details
  .replaceAll('${subject_id}', var_subject_id)
  .replaceAll('${subject_number}', var_subject_number)
  .replaceAll('${subject_job_status}', this.subject_model.job_status)
  .replaceAll('${subject_name}', var_subject_name)
  .replaceAll('${subject_name_4_doc}', var_subject_name_4_doc)
  .replaceAll('${subject_business_name}', var_subject_business_name)
  
  // All these variables are established ans set above before running the merge fields etc,
  //sav_
  .replaceAll('${sav_subject_name}', var_subject_name)
  
  //tested working
  // let var_subject_service_fellow_relationship =  this.subject_service_fellow_relationship
  .replaceAll('${sav_subject_relationship_name}', var_subject_service_fellow_relationship)
  .replaceAll('${subject_relationship_name}', var_subject_service_fellow_relationship)
  
  
  // Get the Outcome Name
  // let var_service_outcome_name = this.subjectServiceOutcome.service_outcome_name
  .replaceAll('${service_outcome_name}', this.var_service_outcome_name)
  //sav
  .replaceAll('${sav_service_outcome_name}', this.var_service_outcome_name)
  
  // Needs testing Exact Service Meithod Name
  // .replaceAll('${exact_service_method_name}', this.subjectExactServiceMethod.service_method_name) // crrently tgrowing errors
  .replaceAll('${exact_service_method_name}', this.var_exact_service_method_name) //
  
  // .replaceAll('${exact_service_method_name}', model.exact_service_method) // if a srvive ????? // required
  
  
  .replaceAll('${location_status_name}', this.var_location_status_name)
  //sav -- 
  .replaceAll('${sav_location_status_name}', this.var_location_status_name)
  
  
  .replaceAll('${location_status_found_name}', this.var_location_status_found_name)
  .replaceAll('${sav_location_status_found_name}', this.var_location_status_found_name)
  
  
  .replaceAll('${f_attempt_subject_type_name}', var_subject_type_name)
  // .replaceAll('${f_attemot_subject_type_name_upper}', this.subject_job_subject_type.job_subject_type_name.toUpperCase())
  .replaceAll('${subject_type_name}', var_subject_type_name)
  .replaceAll('${sav_subject_type_name}', var_subject_type_name)
  
  
  // was missing octoner 2023
  .replaceAll('${property_type_name}', this.var_property_type_name)
  // .replaceAll('${property_type_name}', 'de name')
  
  // rendered_result.replaceAll('${subject_name}', this.subject_model.job_status)
  
  
  
  
  
  
  
  
  // hide anything null or undefined.
    .replaceAll('${undefined}', '')
    .replaceAll('${null}', '')
    .replaceAll('undefined', '') // makes all undefined print empty
    .replaceAll('null', '') // makes all undefined print empty
  
  
  
  
  
      /*
      Job Variables as merge fiels
  str.toUpperCase( ) // function string to upper
  
              $templateProcessor->setValue($f_starter . 'property_occupied_details' , $v->property_occupied_details);
              $templateProcessor->setValue($f_starter . 'property_type_id' , $v->property_type_id);
  
               $templateProcessor->setValue($f_starter . 'property_type_details' , $v->property_type_details);
              $templateProcessor->setValue($f_starter . 'property_type_images' , $v->property_type_images);
  
  
  
  // Mussing and yet to do
      
  $templateProcessor->setValue($f_starter . 'exact_service_method_name' , $json_serviceEM[0]->exact_service_method_name);
     $templateProcessor->setValue($f_starter . 'subject_relationship_name' ,  $json_serviceR[0]->subject_relationship_name);   
  
  
              $templateProcessor->setValue($f_starter . 'subject_name' , $subject_name);
  
  
           
  
                          $templateProcessor->setValue($f_starter . 'subject_file_number' , ucfirst($file_number));
  
  
              $templateProcessor->setValue($f_starter . 'subject_type_name' , $json_serviceST[0]->job_subject_type_name);
              $templateProcessor->setValue($f_starter . 'subject_type_name_upper' , strtoupper($json_serviceST[0]->job_subject_type_name));
  
              // July 2022 Additions
              $templateProcessor->setValue($f_starter . 'subject_number' , $v->subject_number);
  
               $templateProcessor->setValue($f_starter . 'service_file_array' , $sfa_text);
  
                $templateProcessor->setValue($f_starter . 'property_type_name' , $json_servicePT[0]->property_type_name);
  
      */
  
  
  
  // console.log('JObVar1: ' + this.job_model.job_id);
  
      // this.current_job -- job is already looked up onit() - from JobSubject
  
  
        // Goal is to make a function that runs over the rendered result again.
        // This Funtion Just needs to find Once.????
  
  
  
  
  
       this.model.service_paragraph_rendered = rendered_result;
       this.attemptForm.controls['service_paragraph_rendered'].patchValue(rendered_result);
  
  // Filled by running a the function above
      //  this.model.service_paragraph = str3;
      // this.attemptForm.controls['service_paragraph'].patchValue(str3);
  
  
  
  /// I wanting. Run again - use const rendered?_result and run .replaceall()
  
  
      // console.log(rendered_result);
  
  // end merge varibales and string replace funcitons
  
  
              // this.allFileAutomations = JSON.parse(this.system_automation[0].system_file_array);
              // this.allCommunicationsAutomations = JSON.parse(this.system_automation[0].system_communication_array);
              // this.allConditionsAutomations = JSON.parse(this.system_automation[0].system_conditions_array);
  
              // let new_model = {
              //   system_file_array: JSON.parse(this.system_automation[0].system_file_array)
              // }
              // this.getSystemSubjectTemplateDocsArray(new_model);
  
              // let new_model_b = {
              //   system_communication_array: JSON.parse(this.system_automation[0].system_communication_array)
              // }
              // this.getSystemSubjectTemplateDocsArray_Communications(new_model_b);
  
              
              // let new_model_c = {
              //   system_conditions_array: JSON.parse(this.system_automation[0].system_conditions_array)
              // }
              // this.getSystemSubjectTemplateDocsArray_Conditions(new_model_c);
  
  // Load all condition arrays from the subject_service_outcome_templates datatable (ssot_condition_arrays.)
  
  //  // Load all the conditions
  //   this.getSubjectServicesOutcomeTemplates(data)
  
          // this.getSystemLogType(data.system_log_type_id);

          // this.toastr.success("Paragraph Refrehsed")
        },
        err => console.error(err.status)
      );
  }
  



  escapeHtml(text) {
    var map = {
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#039;'
    };
    
    return text.replace(/[&<>"']/g, function(m) { return map[m]; });
  }



  // QuickVariable Functions
  

  
     
  getSubjectServiceType_Q(subject_service_type_id) {
    this._demoService.getSubjectServiceType(subject_service_type_id).subscribe(
       data => { 
        // this.subject_service_type = data;
        let res = data[0]
        this.subject_service_type = DataUtil.parse.parseJson(res);
     
  
  
        
        // return res.subject_service_type_name
        // if ( subject_service_type_id <= 0 ){
        //   this.selected_subject_service_type_description = 'Please Set to default Individual Above';
        //   this.selected_subject_service_type_description = '';
        //   this.selected_subject_service_type_instructions = '';
        //   this.selected_subject_service_type_staff_instructions = '';
  
        // } else{
        // this.selected_subject_service_type_description = res.subject_service_type_description;
        // this.selected_subject_service_type_instructions = res.subject_service_type_instructions;
        // this.selected_subject_service_type_staff_instructions = res.subject_service_type_staff_instructions;
        // }
  
        // // initiate the change of service rule if different or select from drop down.
        // if (subject_service_type_id > 1) {
        // this.setJobServiceRule(res.job_service_rule_id_change_to);
        // this.getJobServiceRule(res.job_service_rule_id_change_to); // sets the descruption information on change.
        // }
  
      },
       err => console.log(err),
       // () => console.log('done loading Trace Types')
     );
   }
  
  
  
   getSubjectServiceOutcome_Q(subject_service_outcome_id) {
    this._demoService.getSubjectServiceOutcome(subject_service_outcome_id).subscribe(
      data => { 
        // this.subjectAttemptType = data;
      let res = data[0]
      this.subjectServiceOutcome = DataUtil.parse.parseJson(res);
      },
      err => console.error(err),
    );
    }
  
    
   getSubjectLocationStatus_Q(subject_location_status_id) {
    this._demoService.getSubjectLocationStatus(subject_location_status_id).subscribe(
      data => { 
        // this.subjectAttemptType = data;
      let res = data[0]
      this.subjectLocationStatus = DataUtil.parse.parseJson(res);
      },
      err => console.error(err),
    );
    }
  
  
    getSubjectLocationStatusFound_Q(subject_location_status_found_id) {
      this._demoService.getSubjectLocationStatusFound(subject_location_status_found_id).subscribe(
        data => { 
          // this.subjectAttemptType = data;
        let res = data[0]
        this.subjectLocationStatusFound = DataUtil.parse.parseJson(res);
        },
        err => console.error(err),
      );
      }
  
  
    getSubjectExactServiceMethod_Q(exact_service_method_id) {
      this._demoService.getExactServiceMethod(exact_service_method_id).subscribe(
        data => { 
          // this.subjectAttemptType = data;
        let res = data[0]
        this.subjectExactServiceMethod = DataUtil.parse.parseJson(res);
        },
        err => console.error(err),
      );
      }
    
  
  
  
   getSubjectAttemptType_Q(subject_service_type_id) {
    this._demoService.getSubjectAttemptType(subject_service_type_id).subscribe(
      data => { 
        // this.subjectAttemptType = data;
      let res = data[0]
      this.subject_attempt_type = DataUtil.parse.parseJson(res);
      },
      err => console.error(err),
    );
    }
  
    getSubjectRelationship_Q(subject_relationship_id) {
      this._demoService.getSubjectRelationship(subject_relationship_id).subscribe(
        data => { 
          let res = data[0]
          this.serviceFellowRelationship = data;
          this.subject_service_fellow_relationship = DataUtil.parse.parseJson(res);
        },
        err => console.error(err),
      );
      }
  
  
   getBrand_Q(brand_id) {
        this._demoService.getBrandById(brand_id).subscribe(
          (data) => {
            // this.brand_data = data;
    
            let res = data[0];
            this.subject_service_agent = DataUtil.parse.parseJson(res);
            // this.allClientEmailRecipients = data;
    
            // let newArr = data
            // let  count_of_items = Object.keys(newArr).length;
            //   // need to do a loop of subject_billing items (.length)
            //   for (let i = 0; i < count_of_items; i++) {
            //   let res = newArr[i];
            //   this.allRecipients.push({
            //     recipient_name: res.name + ' - Client Report',
            //     recipient_email_address: res.email,
            //     recipient_brand_id: res.brand_id,
            //     recipient_brand_type_id: res.brand_type_id,
            //     recipient_user_id: null,
            //     recipient_user_level_id: null,
            //     recipient_type_name: 'Client Report',
            //   });
            //   } // end for loop
            // this.allRecipients = this.allRecipients; // ?? this may be causing errors.
    
          },
          (err) => console.error(err),
          () => console.log('Brand Loaded.')
        );
      }

      getBrand_report_Q(brand_id) {
        this._demoService.getBrandById(brand_id).subscribe(
          (data) => {
            // this.brand_data = data;
    
            let res = data[0];
            this.job_report_client = DataUtil.parse.parseJson(res);
            // this.allClientEmailRecipients = data;
    
            // let newArr = data
            // let  count_of_items = Object.keys(newArr).length;
            //   // need to do a loop of subject_billing items (.length)
            //   for (let i = 0; i < count_of_items; i++) {
            //   let res = newArr[i];
            //   this.allRecipients.push({
            //     recipient_name: res.name + ' - Client Report',
            //     recipient_email_address: res.email,
            //     recipient_brand_id: res.brand_id,
            //     recipient_brand_type_id: res.brand_type_id,
            //     recipient_user_id: null,
            //     recipient_user_level_id: null,
            //     recipient_type_name: 'Client Report',
            //   });
            //   } // end for loop
            // this.allRecipients = this.allRecipients; // ?? this may be causing errors.
    
          },
          (err) => console.error(err),
          () => console.log('Brand Loaded.')
        );
      }
  
  
  
      getServiceMethod_Q(subject_service_method_id) {
        this._demoService.getServiceMethod(subject_service_method_id).subscribe(
          data => { 
            let res = data[0]
            this.serviceMethod = data;
            this.subject_service_method = DataUtil.parse.parseJson(res);
          },
          err => console.error(err),
        );
        }



// Subject Type Name Lookup
getJobSubjectType_Q(job_subject_type_id) {
  this._demoService.getJobSubjectType(job_subject_type_id).subscribe(
     data => { 
      let res = data[0]
      this.job_subject_type = data;
      this.subject_job_subject_type = DataUtil.parse.parseJson(res);
    
    },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
 }




 getPropertyType(property_type_id) {
  this._demoService.getPropertyType(property_type_id).subscribe(
    data => { 
      // this.subjectAttemptPropertyType = data;
  let res = data[0]
  this.subjectAttemptPropertyType = DataUtil.parse.parseJson(res);
    
    },
    err => console.error(err),
  );
  }


  
    // ::@https://stackblitz.com/edit/angular-bmxbmy?file=src%2Fapp%2Fapp.component.html
    getHtml(html){
      return this.sanitizer.bypassSecurityTrustHtml(html);
    }
  
      // ::@https://stackoverflow.com/questions/29369512/render-html-entities-string-in-html-with-angular properway to do it (decode html special charactors for dispaly)
    // WORKS as I created my own function from this articel == pretty well convers
    transform2(value: any, args?: any): any {
      const doc = new DOMParser().parseFromString(value, 'text/html');
      return doc.documentElement.textContent;
    }
  
    stripTagsP(textToEscape) {
      // return $('<p></p>').html(textToEscape).text() // Removes all elected tag....

    // let  convert_textToEscape = $('<p></p>').html(textToEscape).text() // does both.

      //https://www.servicenow.com/community/developer-forum/using-striphtml-but-keep-line-breaks/m-p/2609400
      return textToEscape.replace(/<(?!br\s*\/?)[^>]+>/g, "");  // leaves line breakes
  
  // do nothing.
  return textToEscape;
  
    }

  
    copyToClipboard(id) {
      const content = document.getElementById(id).innerHTML; // copy all formatting.
      // const content = document.getElementById('note_content_' + id).innerText; // wet to copy text and formatting only
      this.clipboard.copy(content);
      this,this.toastr.info(" Copied")
      // this.copyInGrid('btnTwo', id);
    }
    
    copyToClipboardPlainText(id) {
      const content = document.getElementById(id).innerText; // copy all formatting.
      // const content = document.getElementById('note_content_' + id).innerText; // wet to copy text and formatting only
      // this.clipboard.copy(this.removeTags(content));
      this.clipboard.copy(content);
      this,this.toastr.info(" Copied")
      // this.copyInGrid('btnTwo', id);
    }


    importPrevContentToHTML(id, content_sent, model) {
      if (confirm('Are you sure? Warning: This action will replace any content in the new "Editor" for this specific field.' + id)) {
      // model.id = id+'_HTML'
      // const content = document.getElementById(id).innerText; // copy all formatting.
      // const content = document.getElementById('note_content_' + id).innerText; // wet to copy text and formatting only
      // this.clipboard.copy(this.removeTags(content));
      // this.clipboard.copy(content);

      const content = content_sent; // copy all formatting.
      // this.attemptForm.controls['updated_by'].setValue(id+'_HTML');
      

      // this.attemptForm.controls['general_notes_HTML'].setValue(content);
      this.attemptForm.controls[id+'_HTML'].setValue(content);




      this,this.toastr.info("Updated Version: " + id+'_HTML')
      this.LoadSubjectserviceOutcomeTemplateParagraph(model)
      // this.copyInGrid('btnTwo', id);
      }
    }
    
    // shows pre version field by id // ngif statments hard coded on each old text box
    showPrevVersion(id) {
      this.showPrevVersion_Field = id;
    
    } 

    hidePrevVersion() {
      this.showPrevVersion_Field = '';
    
    } 
  
  

            // Removes HTML from a sron
        // ::@ https://www.geeksforgeeks.org/how-to-strip-out-html-tags-from-a-string-using-javascript/
  removeTags(str) {
    if ((str===null) || (str===''))
        return false;
    else
        str = str.toString();
          
    // Regular expression to identify HTML tags in
    // the input string. Replacing the identified
    // HTML tag with a null string.
    return str.replace( /(<([^>]+)>)/ig, '');
}

  
    onChangePromtSave(any) {
      //  alert('you have made changes, please remember to save!');
      //  console.log('form changed');
       this.changes_made = null;
      }
    
      onChangePromtSaveHide() {
        //  alert('you have made changes, please remember to save!');
        //  console.log('form changed');
         this.changes_made = 1;
        }
  




        // onTimeChange_NoZone(model) {
        //   if (model.time_service instanceof Date) {
        //     const hours = model.time_service.getHours().toString().padStart(2, '0');
        //     const minutes = model.time_service.getMinutes().toString().padStart(2, '0');
        
        //     // Save a pure 24h time string
        //     // model.time_service_text = `${hours}:${minutes}`;
        
        //      // Optional: If you want 12h format with AM/PM
        //      const ampm = +hours >= 12 ? 'PM' : 'AM';
        //      const hour12 = ((+hours % 12) || 12).toString();
        //     model.time_service_text = `${hour12}:${minutes} ${ampm}`;


            
        //     // Optional: If you want 12h format with AM/PM
        //     // const ampm = +hours >= 12 ? 'PM' : 'AM';
        //     // const hour12 = ((+hours % 12) || 12).toString();
        //     model.time_service_text_12hr = `${hour12}:${minutes} ${ampm}`;
        //   }
        // }
        







        onTimeChange_NoZone(model) {
          
          if(model.time_service_24hr != null){
          this.model.time_service = this.setTimeServiceFromText(model.date_service, model.time_service_24hr);
             }

          
                  // This changes the time of the service_text
            if (model.time_service instanceof Date) {
              const hours = model.time_service.getHours().toString().padStart(2, '0');
              const minutes = model.time_service.getMinutes().toString().padStart(2, '0');
          
          
              // Optional: If you want 12h format with AM/PM
              const ampm = +hours >= 12 ? 'PM' : 'AM';
              const hour12 = ((+hours % 12) || 12).toString();
          
              // Save a pure 24h time string
              // model.time_service_text = `${hours}:${minutes}`;
              model.time_service_text = `${hour12}:${minutes} ${ampm}`; // so that we get am and pm?
          
          
              model.time_service_text_12hr = `${hour12}:${minutes} ${ampm}`;
            }
          
          }
          
          
          
          // I need a function to set the service time based on the selection, and that way I can make the system backwards compatable with the dates
          setTimeServiceFromText(dateStr: string | Date, timeStr: any): Date {
           
            // if (!dateStr || !timeStr) return null;
          
            const date = new Date(dateStr);
            if (isNaN(date.getTime())) return null;
          
            // Extract parts from time string (e.g., "3:45 PM")
            const timeParts = timeStr.trim().match(/(\d{1,2}):(\d{2})\s*(AM|PM)?/i);
            if (!timeParts) {
              // this.toastr.error('no parts time parts.')
              return null;
            } 
          
            let [_, hourStr, minuteStr, ampm] = timeParts;
            let hour = parseInt(hourStr, 10);
            const minute = parseInt(minuteStr, 10);
          
            if (ampm) {
              ampm = ampm.toUpperCase();
              if (ampm === 'PM' && hour < 12) hour += 12;
              if (ampm === 'AM' && hour === 12) hour = 0;
            }
          
            // Clone date and set time
            const combined = new Date(date);
            combined.setHours(hour, minute, 0, 0); // zero seconds/milliseconds
          
            return combined;
          }




          // Function to get the time_service_24hr on load if it does not exist - for backwards compatablity.
          normalizeTimeService24(model: any): void {
            
            
            // If already set, skip
            if (model.time_service_24 != null){
            this.toastr.success('already set')
            return;
            }

            // could be one of two variables set in the data.
            let time12
            
            if (model.time_service_text != null){
              // this.toastr.info('time is text')
              time12  = model.time_service_text?.trim();
            }
            // it may have been set manually this ensures it gets the time for these cases... as for backwards compatablity.
            if (model.time_service_text == null){
              // this.toastr.info('time is text dynamic')
              time12 = model.time_service_text_dynamic?.trim();
            }            
            
            
            if (!time12) return;
          
            // const match = time12.match(/^(\d{1,2}):(\d{2})\s?(AM|PM)$/i);
            const match = time12.match(/^(\d{1,2}):(\d{2})\s*(AM|PM)$/i);
            if (!match) {
            //  this.toastr.error('could not find: ' + match)
              return;
            }
            let [, hourStr, minuteStr, ampm] = match;
            let hour = parseInt(hourStr, 10);
            const minute = minuteStr;
          
            ampm = ampm.toUpperCase();
            if (ampm === 'PM' && hour < 12) hour += 12;
            if (ampm === 'AM' && hour === 12) hour = 0;
          
            const hour24 = hour.toString().padStart(2, '0');
            model.time_service_24 = `${hour24}:${minute}`;
            this.model.time_service_24hr = `${hour24}:${minute}`;
            // Do I need to set the form control?


            // new update the time again to make the entire sytem cimpatable..
            this.model.time_service = this.setTimeServiceFromText(model.date_service, this.model.time_service_24hr);

          }


getSystemResolutionsArray(request_array) {
  this._demoService.getSystemResolutionsArray(request_array).subscribe(
     data => { this.subject_service_resolution_outcomes = data;
      this.subject_service_resolution_outcomes_by_type = this.groupResolutionOutcomesByType(data);
      this.syncResolutionOutcomeAnswersFromModel(this.model);
      let res = data[0];

      // this.arrCase = data as object [];  // FILL THE ARRAY WITH DATA.
      // // console.log(this.arrCase);
      // this.Items = data['Items'] ;
      // this.sent_data = this.Items;
      // this.sent_data = this.myob_account_codes;

    },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
 }

groupResolutionOutcomesByType(outcomes: any): any[] {
  const grouped = [];
  Object(outcomes || []).forEach((outcome) => {
    if (outcome.is_active != null && outcome.is_active !== 1 && outcome.is_active !== '1' && outcome.is_active !== true && outcome.is_active !== 'Y') {
      return;
    }
    if (outcome.is_visible != null && outcome.is_visible !== '' && outcome.is_visible !== 1 && outcome.is_visible !== '1' && outcome.is_visible !== true && outcome.is_visible !== 'Y') {
      return;
    }
    const typeActive = outcome.subject_service_resolution_outcome_type_is_active;
    if (typeActive != null && typeActive !== 1 && typeActive !== '1' && typeActive !== true && typeActive !== 'Y') {
      return;
    }
    const typeId = Number(outcome.subject_service_resolution_outcome_type_id || 0);
    const typeName = outcome.subject_service_resolution_outcome_type_name || 'Unassigned';
    let group = grouped.find(item => item.type_id === typeId);
    if (!group) {
      group = { type_id: typeId, type_name: typeName, outcomes: [] };
      grouped.push(group);
    }
    group.outcomes.push(outcome);
  });
  return grouped;
}

syncResolutionOutcomeAnswersFromModel(model) {
  if (!model) {
    return;
  }
  let answers = [];
  if (model.subject_service_resolution_outcome_type_answer_array) {
    try {
      answers = typeof model.subject_service_resolution_outcome_type_answer_array === 'string'
        ? JSON.parse(model.subject_service_resolution_outcome_type_answer_array)
        : model.subject_service_resolution_outcome_type_answer_array;
      if (typeof answers === 'string') {
        answers = JSON.parse(answers);
      }
    } catch (e) {
      answers = [];
    }
  }
  const answerList = Array.isArray(answers)
    ? answers
    : Object.keys(answers || {}).map(key => answers[key]);
  answerList.forEach(answer => {
    if (answer && answer.type_id != null && answer.outcome_id != null) {
      this.resolutionOutcomeAnswersByType[Number(answer.type_id)] = String(answer.outcome_id);
    }
  });
  if (model.subject_service_resolution_outcome_id != null && model.subject_service_resolution_outcome_id !== '' && Number(model.subject_service_resolution_outcome_id) > 0) {
    const legacyOutcomeId = String(model.subject_service_resolution_outcome_id);
    let targetTypeId: any = null;
    Object(this.subject_service_resolution_outcomes_by_type || []).forEach(group => {
      const groupOutcomes = Array.isArray(group.outcomes)
        ? group.outcomes
        : Object.keys(group.outcomes || {}).map(key => group.outcomes[key]);
      const found = groupOutcomes.some((outcome: any) => String(outcome.id) === legacyOutcomeId);
      if (found) {
        targetTypeId = Number(group.type_id);
      }
    });
    if (targetTypeId != null && !this.resolutionOutcomeAnswersByType[targetTypeId]) {
      this.resolutionOutcomeAnswersByType[targetTypeId] = legacyOutcomeId;
    } else if (targetTypeId == null && !this.resolutionOutcomeAnswersByType[1]) {
      this.resolutionOutcomeAnswersByType[1] = legacyOutcomeId;
    }
  }
}

prepareResolutionOutcomeAnswers(model) {
  const answers = [];
  let primaryOutcomeId = null;
  Object(this.subject_service_resolution_outcomes_by_type || []).forEach(group => {
    const outcomeId = this.resolutionOutcomeAnswersByType[group.type_id];
    if (outcomeId != null && outcomeId !== '') {
      answers.push({
        type_id: Number(group.type_id),
        outcome_id: Number(outcomeId)
      });
      if (
        primaryOutcomeId == null
        && (
          Number(group.type_id) === 1
          || String(group.type_name || '').toLowerCase() === 'primary'
        )
      ) {
        primaryOutcomeId = Number(outcomeId);
      }
    }
  });
  model.subject_service_resolution_outcome_type_answer_array = JSON.stringify(answers);
  model.subject_service_resolution_outcome_id = primaryOutcomeId || (answers[0] ? answers[0].outcome_id : model.subject_service_resolution_outcome_id || null);
}




}
